import { market } from "../market/ba";
import { invite } from '../invite/ba';
import { property } from '../property/ba';
import {advertise} from '../advertise/ba';
import {login, download} from '../login/ba';
import {trading} from '../trading1/ba';
import { contest } from "../contest/ba";
import { merchandiser, common, tableList, dialog, codeInfo, hyy as contractHyy, placeOrder, codelist, panKou } from "../merchandiser/ba";
import { games } from '../games/ba';
import { taskCenter } from "../task/ba";
import { ieo } from "../ieo/ba";
import { earn } from "../earn/ba";
import { tradingContest } from "../tradingContest/ba";
import { agent } from "../agent/ba";
import { live } from "../live/ba";
import { hongbao } from "../hongbao/ba";


const time = {
  r: "Hari",
  s: "Jam",
  f: "Menit",
  m: "Detik",
};
// 状态
const state = {
  preheatIng: "Pemanasan",
  purchaseIng: "Sedang Dibeli",
  over: "Telah Berakhir",
  finish: "Telah Selesai",
  noData: "Belum Ada Data",
  process: "Sedang Bantu",
  sellout: "Telah Habis",
};
// 模板文字
const text = {
  now: "Sedang Berlangsung",
  start: "Menuju Mulai Putaran Ini",
  end: "Menuju Akhir Putaran Ini",
  jd: "Progress Putaran Ini",
  complete: "Telah Selesai",
  limited: "Harga Diskon Terbatas Waktu",

  finish: "Telah Selesai",
  subscribing: "Sedang Berlangganan",
  subscribeNow: "Berlangganan Sekarang",
  buyStart: "Menuju Mulai Berlangganan",
  buyEnd: "Menuju Akhir Berlangganan",
  projectAmount: "Jumlah Bagian Proyek",
  quota: "Kuota Per Bagian",
  buyPrice: "Harga Berlangganan",
  buyLimit: "Batas Berlangganan",
  buyAmount: "Jumlah Berlangganan",
  buyPos: "Holding Koin Berlangganan",
  startDate: "Waktu Mulai",
  endDate: "Waktu Berakhir",
  projectSuppot: "Dukungan Proyek",
  websit: "Situs Web Proyek",
  projectDetail: "Detail Proyek",
  cycle: "Siklus Berlangganan",
  all: "Semua",
  step1: "Pemanasan",
  step2: "Berlangganan",
  step3: "Pengundian",
  step4: "Pengumuman Hasil",
  subOrder: "Order Berlangganan",
  myOrder: "Order yang Berhasil",
  proCoin: "Koin Proyek",
  buyCoin: "Koin Berlangganan",
  orderDate: "Waktu Order",
  issuanceQuota: "Kuota Distribusi",
  dealAmount: "Jumlah Eksekusi",
  dealPrice: "Jumlah Eksekusi",
  status: "Status",
  ctrl: "Operasi",
  checkOrder: "Lihat Nomor Undian",
  subNum: "Nomor Undian Berlangganan",
  myNum: "Nomor Undian yang Berhasil",
  status0: "Telah Berlangganan",
  status1: "Menunggu Pemotongan",
  status2: "Telah Selesai",
  conditionTerm1: "Sebelum waktu mulai berlangganan * hari,",
  conditionTerm2: "Pasangan dagang *",
  conditionTerm3: "Semua Pasangan Dagang",
  conditionTerm4: "Nilai kumulatif total jumlah transaksi (USDT) dalam perdagangan spot setiap mencapai *, dapat berlangganan 1 bagian",
  noData: "Belum Ada Data",
  qgsc: "Pembelian & Locking",
  yhsg: "Berlangganan Undian",
  sgsb: "Berlangganan Gagal",

  supply: "Kuota Putaran Ini",
  rate: "Rasio Konversi",
  ceiling: "Batas Bantuan",
  xmwc: "Proyek Telah Selesai",
  xmze: "Total Proyek",
  zkjj: "Harga Rata-rata Diskon",
  cyrs: "Jumlah Partisipan",
  round: "Putaran ke-[*]",
  r: "Orang",
  cgqg: "Berhasil Membeli",
  cgzl: "Berhasil Membantu",
  xmed: "Kuota Proyek",
  kszl: "Waktu Mulai Bantuan",
  ksqg: "Waktu Mulai Pembelian",
  jsqg: "Waktu Berakhir Pembelian",
  jszl: "Waktu Berakhir Bantuan",
  hdgz: "Aturan Aktivitas",
  xmjs: "Pengenalan Proyek",
  tcqr: "Setelah Anda keluar dan mengonfirmasi pembayaran, Anda mungkin akan kehilangan peluang untuk mengikuti aktivitas pembelian kilat ini. Harap berhati-hati!",
  jxtc: "Lanjutkan Keluar",
  fhzf: "Kembali ke Pembayaran",
  qgrsd: "Saat ini banyak orang yang membeli, sedang berusaha membeli, harap bersabar!",
  zltcqr: "Setelah Anda keluar dan mengonfirmasi pembayaran, Anda mungkin akan kehilangan peluang untuk mengikuti aktivitas bantuan ini. Harap berhati-hati!",
  zlqgrsd: "Saat ini banyak orang yang membantu, harap bersabar!",
  wxts: "Pemberitahuan: Harap konfirmasi pembayaran secepatnya, pembayaran akan timeout dan jendela akan ditutup jika tidak diselesaikan dalam [*] menit.",
};

const seckill = {
  sgno: "Anda Belum Memenuhi Syarat Berlangganan",
  srjymm: "Masukkan Kata Sandi Transaksi",
  ljzf: "Bayar Sekarang",
};
const apply = {
  condition: "Syarat Berlangganan",
  apply: "Berlangganan Sekarang",
  buyPrice: "Harga Berlangganan",
  buyAmount: "Jumlah Berlangganan",
  applyAmount: "Jumlah Berlangganan",
  forget: "Lupa Kata Sandi Transaksi?",
  noAmount: "Masukkan Jumlah Berlangganan",
  buyLimit: "Batas Berlangganan",
  success: "Berlangganan Berhasil!",
  paySummary:"Pemberitahuan: Harap konfirmasi pembayaran secepatnya, pembayaran akan timeout dan jendela akan ditutup jika tidak diselesaikan dalam <b>3 menit</b>",
  appFull: "Jumlah Berlangganan Terlalu Besar",
  seckill_async_fail_13: "Interval waktu antara dua kali berlangganan adalah {} menit",
};

const seckillRes = {
  seckill_async_3: "Sedang Membayar, harap tunggu!",
  seckill_async_5: "Pembatalan Berhasil",
  seckill_async_fail_1: "Maaf! Silakan refresh halaman dan coba lagi!",
  seckill_async_fail_2: "Maaf! Silakan refresh halaman dan coba lagi!",
  seckill_async_fail_3: "Maaf! Silakan refresh halaman dan coba lagi!",
  seckill_async_fail_4: "Maaf! Kuota telah habis!",
  seckill_async_fail_5: "Maaf! Pembayaran telah timeout, silakan coba lagi!",
  seckill_async_fail_6: "Kata sandi transaksi salah, silakan masukkan kembali!",
  seckill_async_fail_7: "Kesalahan kata sandi transaksi melebihi batas, silakan coba lagi nanti!",
  seckill_async_fail_8: "Maaf! Pembayaran telah timeout, silakan coba lagi!",
  seckill_async_fail_9: "Maaf! Kuota telah habis, semoga berhasil lain kali!",
  seckill_async_fail_10: "Saat ini banyak orang yang membeli, silakan coba lagi nanti!",
  seckill_async_fail_11: "Verifikasi perilaku gagal!",
};
const header = {
  zcgl: "Manajemen Aset",
  zczh: "Akun Aset",
  bbzh: "Akun Spot",
  fbzh: "Akun Beli Koin",
  bdbzh: "Akun Pinjaman Koin",
  wdgl: "Manajemen Order",
  lswt: "Order Sejarah",
  qbhz: "Transfer Dompet Timbal Balik",
  yhzx: "Pusat Pengguna",
  wdhb: "Amplop Saya",
  openOrder: "Order Saat Ini",
  dealStats: "Statistik Eksekusi",
  totalAsset: "Total Perkiraan Aset",
  cz: "Akun Kontrak",
  gmcnyt: "Beli CNYT",
  yqfy: "Undang & Dapatkan Komisi",
  hbthhr: "Mitra HBT",
  tczh: "Keluar Akun",
  moreNew: "Pengumuman Lainnya",
  gfgg: "Pengumuman Resmi",
  zxxw: "Berita Terbaru",
  ckgd: "Lihat Selengkapnya",
  bbdd: "Order Spot",
  bbwhydd: "Order Kontrak Abadi Coin-M",
  etfdd: "Order ETF",
  fbdd: "Order Fiat",
};

const recommend = {
  vol24h: "Volume 24H",
  jyd: "Pasangan Dagang",
  jydlx: "Jenis Pasangan Dagang",
  zxj: "Harga Terbaru",
  change24: "Naik/Turun 24H",
  line24: "Tren Harga (3 Hari)",
};

const hyy = {
  bkt: "Tidak Buka",
  wqdkt: "Saya Yakin Buka",
  kt12: "1. Sebelum berpartisipasi, Anda harus memahami secara menyeluruh pengetahuan dasar dan risiko terkait perdagangan kontrak mata uang digital serta semua aturan bisnis terkait yang terkait dengan partisipasi dalam perdagangan derivatif.",
  kt13: "2. Pemberitahuan risiko di atas hanya bersifat enumeratif dan tidak mencantumkan secara lengkap semua faktor risiko yang terkait dengan perdagangan derivatif aset digital. Sebelum berinvestasi dalam perdagangan derivatif aset digital, investor harus memahami dan menguasai faktor risiko lain yang mungkin ada.",
  kt14: "3. Kami dengan tulus berharap dan menyarankan investor, berdasarkan kemampuan menanggung risiko dan kondisi aktual mereka sendiri, untuk memutuskan dengan hati-hati apakah akan berpartisipasi dalam perdagangan kontrak ini, dan mengalokasikan aset digital mereka secara wajar.",
  kt0: "Pengguna Terkasih:",
  kt1: "Anda belum membuka akun kontrak dan izin perdagangan kontrak, silakan baca dengan cermat konten berikut sebelum memutuskan untuk membuka:",
  kt2: "1. Saat Anda melakukan perdagangan di pasar kontrak, jika pergerakan harga pasar tidak menguntungkan Anda dan menyebabkan margin posisi Anda tidak mencukupi, BiKing Kontrak Abadi akan melakukan likuidasi posisi Anda sesuai dengan kesepakatan sistem dan mengungkapkan detail likuidasi.",
  kt3: "2. Anda harus membaca dan mematuhi aturan bisnis BiKing Kontrak Abadi, memahami mekanisme dan prinsip operasi kontrak, dan memahami berbagai risiko pasar.",
  kt4: "4. BiKing Kontrak Abadi terhubung ke sistem perdagangan kontrak, keuntungan dan kerugian posisi pengguna berfluktuasi dengan fluktuasi pasar kontrak. Ketika kerugian besar, likuidasi juga dapat terjadi dalam sistem perdagangan kontrak. Silakan pengguna memutuskan perilaku perdagangan mereka sendiri berdasarkan pasar kontrak, menanggung keuntungan dan kerugian sendiri. Dengan demikian, BiKing tidak bertanggung jawab atas segala jaminan yang disiratkan atau ditetapkan.",
  kt5: "5. Silakan pengguna secara sadar mematuhi aturan terkait platform, mematuhi hukum dan peraturan negara dan wilayah terkait. Jika akun kontrak pengguna abnormal karena operasi yang melanggar aturan, akun akan dibekukan, pengguna tidak dapat beroperasi, dan platform juga tidak dapat melakukan likuidasi untuk pengguna. Jika hal ini menyebabkan kerugian atau likuidasi, platform tidak akan bertanggung jawab.",
  kt6: "6. Perdagangan derivatif aset digital mungkin menghadapi risiko pengawasan kebijakan dalam yurisdiksi tertentu. Sebelum melakukan perdagangan, Anda perlu membuat penilaian dengan hati-hati dengan memahami latar belakang pengawasan kebijakan wilayah perdagangan. Karena perubahan hukum, peraturan, kebijakan di negara dan wilayah terkait, modifikasi aturan perdagangan bursa kontrak, penerapan tindakan darurat, dll., BiKing akan mengungkapkan pernyataan sebelumnya. Posisi terbuka yang Anda pegang mungkin tidak dapat dipertahankan, tetapi saldo margin dan keuntungan masih akan direalisasikan.",
  kt7: "7. Karena alasan di luar kendali platform, seperti force majeure (gempa bumi, banjir, kebakaran, dll.) atau kegagalan sistem komputer, sistem komunikasi, dll., perintah Anda mungkin tidak dapat dieksekusi atau dieksekusi seluruhnya, dan kerugian yang diakibatkannya mungkin harus ditanggung sendiri.",
  kt8: "8. Perdagangan \"Lindung Nilai\" menghadapi risiko yang sama dengan perdagangan spekulatif, yaitu risiko yang ditimbulkan oleh fluktuasi harga.",
  kta9: "9. Jika Anda tidak melakukan verifikasi identitas atau tidak mengikat verifikasi Google, atau meminjamkan akun kepada orang lain untuk dioperasikan, hal ini dapat memengaruhi keamanan margin kontrak Anda.",
  kta10: "3. Dalam kondisi pasar tertentu yang ekstrem, Anda mungkin mengalami kesulitan atau tidak dapat menutup posisi terbuka yang Anda pegang. Misalnya, ketika keuntungan Anda menempati peringkat pertama dalam PnL leverage efektif seluruh pasar kontrak, dan pihak lawan memiliki dana asuransi yang tidak cukup untuk menutupi kerugian insolvensi mereka.",
  kt9: "Saya telah membaca dengan cermat dan bersedia menanggung risiko",
  kt10: "Buka Akun Kontrak dan Izin Perdagangan Kontrak",
  zjhz: "Transfer Dana",
  ljhz: "Transfer Sekarang",
  qx: "Batalkan Transfer",
  khz: "Dapat Ditransfer",
  qxz: "Silakan Pilih",
  bz: "Mata Uang",
  c: "Dari",
  zz: "Ke",
  sl: "Jumlah",
  qb: "Semua",
  ktcg: "Pembukaan Berhasil",
  ktsb: "Pembukaan Gagal",
  hzcg: "Transfer Berhasil",
  hzsb: "Transfer Gagal",
  wyyd: "", //未勾选已经阅读提示文案
  tc: "Keluar",
  warning1: "Silakan Pilih Mata Uang",
  warning2: "Akun Sumber Tidak Boleh Kosong",
  warning3: "Akun Tujuan Tidak Boleh Kosong",
  warning4: "Masukkan angka yang tidak lebih besar dari jumlah yang dapat ditransfer",
  warning5: "Maksimal 4 desimal",
  gb: "Tutup",
  openSuccess: "Anda Telah Membuka Perdagangan Kontrak",
  openSuccessTip: "Silakan transfer dana ke akun kontrak",
  wsmyz: "Anda Belum Menyelesaikan Verifikasi Identitas",
  hdnm: "Selesaikan verifikasi identitas dan transfer bersih kumulatif [*]USDT untuk mendapatkan [**]USDT泥码",
  nmjl: "Catatan泥码",
  nmhzjl: "Catatan Hadiah泥码",
  gxn: "Selamat!",
  qwjy: "Pergi ke Perdagangan",
  yfrndhyzh: "Telah dimasukkan ke akun kontrak Anda",
  nzxy: "Anda hanya perlu mentransfer [*]USDT lagi ke akun kontrak untuk mendapatkan [**]USDT泥码",
  nmssm: "Apa itu泥码",
  nm: "泥码",
  nxhyzh: "Anda ke akun kontrak",
  text1: "Transfer bersih kumulatif ke akun kontrak [*]USDT atau lebih, dapatkan",
  text2: "Anda hanya perlu mentransfer [*]USDT lagi ke akun kontrak",
  text3: "dapatkan [*]USDT泥码",
  text4: "Saldo",
  text5: "Anda telah mentransfer bersih kumulatif [*]USDT atau lebih ke akun kontrak, telah mendapatkan",
  not_get_nm: "Maaf, aktivitas泥码telah berakhir, transfer ini tidak mendapatkan泥码",
  yijie: "1、Tahap Satu",
  erjie: "2、Tahap Dua",
  ljjhr: "Akumulasi Transfer Bersih Masuk",
  khd: "Dapat Memperoleh",
  hysnm: "Kontrak Hadiah泥码",
  bbgg: "Kontrak Abadi Leverage 100x",
  hdsj: "Waktu Aktivitas：",
  hdxq: "Detail Aktivitas",
  ljhd: "Klaim Sekarang",
  xdxd: "First Come First Served",
  ylnnz: "Menang Anda Bawa, Kalah Jadi Milik Saya",
};

const Verification = {
  channel: "Saluran Verifikasi Resmi",
  verify: "Masukkan informasi yang perlu diverifikasi",
  notes: "Tips Keamanan",
  notes1:"1. Semua email, akun WeChat, akun QQ, domain, dan akun media yang terkait dengan BiKing dapat diverifikasi di sini.",
  notes2: "2. Akun media sosial (Weibo, Twitter, dll.) hanya mendukung pencarian nama, perlu membedakan huruf besar/kecil.",
  notes3: "3. Jika ada pertanyaan tentang hasil verifikasi, Anda dapat menghubungi layanan pelanggan resmi di situs web resmi atau APP untuk konfirmasi ulang.",
  error: "Verifikasi Gagal",
  error1: "Informasi yang Anda cari",
  error2: "bukan saluran yang disertifikasi resmi, harap perhatikan keamanan aset, waspada terhadap kebocoran informasi pribadi.",
  errorNote: "Hal yang Perlu Diperhatikan",
  errorNote1:"1. Saat ini saluran verifikasi resmi hanya mendukung verifikasi email, akun WeChat resmi, akun QQ, domain, dan akun media sosial ",
  errorNote2: "2. Alat obrolan seperti WeChat hanya mendukung pencarian dengan akun (bukan nama panggilan) ",
  errorNote3: "3. Akun media sosial hanya mendukung pencarian nama, perlu membedakan huruf besar/kecil",
  success: "Verifikasi Berhasil",
  success1: "Informasi yang Anda cari：",
  success2: "adalah",
  success3: " yang disertifikasi resmi oleh BiKing, jika nomor/akun ini muncul di saluran lain, jangan percaya, harap perhatikan keamanan aset.",
  more: "Lihat Selengkapnya",
  know: "Saya Telah Tahu",
  weChat: "WeChat",
  name: "Domain",
  webo: "Weibo",
  twitter: "Twitter",
  email: "Email",
  contact: "Hubungi Layanan Pelanggan",
  bannerTip:"Untuk mencegah penipuan atas nama BiKing oleh pihak yang tidak bertanggung jawab, Anda dapat mengonfirmasi melalui halaman ini apakah telepon, WeChat, dll. yang menghubungi Anda adalah saluran resmi BiKing.",
};
const index = {
  downloadIos: 'Unduh AppStore',
  downloadAndroid: 'Unduh Android',
  downloadGoogle: 'Unduh Google Play'
};

const indexPage = {
  gfgg: "Pengumuman Resmi",
  zxxw: "Berita Terbaru",
  ckgd: "Lihat Selengkapnya",
};

const NAVS = {
  ty: 'Piala Eropa',
  hqsj: 'Pasar',
  game: 'Game',
  fx: 'Temukan',
  sj: 'Data',
  fb: "Beli Koin",
  bb: "Perdagangan Spot",
  jr: "Keuangan",
  jyds: "Kompetisi Perdagangan",
  hbhd: "Acara Paket Merah",
  gg: "Perdagangan Margin",
  yxhy: "Kontrak Abadi",
  eft: "Perdagangan ETF",
  flhd: "Aktivitas Bonus",
  flzx: "Pusat Bonus",
  fast: "Perdagangan Cepat",
  spec: "Perdagangan Profesional",
  login: "Login",
  rig: "Daftar",
  downapp: "Unduh BiKing APP",
  downappsum: "Pengalaman Lancar Isi/Tarik Detik",
  zichan: "Aset",
  order: "Pesanan",
  qbhz: "Transfer Dompet Timbal Balik",
  lang: "Bahasa",
  calc: "Metode Penilaian",

  mb: "Beli Koin",
  hq: "Pasar",
  hy: "Kontrak",
  jy: "Perdagangan",
  lc: "Earn",
  fs: "Fansup",
  xy: "Akademi",
  byxy: "Akademi BiKing",
  byyx: "Pilihan Riset BiKing",
  coins: "Poin COINS",
  gd: "Lainnya",
  yqhy: "Undang Teman",
  rwzx: "Pusat Tugas",
  bbms: "Beli aset digital seperti Bitcoin dengan USDT",
  ggms: "Platform meminjamkan aset digital, memperbesar keuntungan dan risiko",
  yxms: "Dukungan leverage 100x, operasi mudah dan beragam",
  etfms: "Perbesar keuntungan, tanpa risiko likuidasi",
  pool: "Kolam Bersama",
  czzn: 'Panduan Operasi',
  gywm: 'Tentang Kami',
  zhxx: 'Informasi Akun',
  gd:"Kontrak Salin",
  yxhy: "Kontrak Abadi",
  zjhy: "Kontrak Bonus",
  product: "Produk",
};

const FOOTERS = {
  zxkf: "Layanan Pelanggan Online",
  fawu: "Saran Hukum",

  us: "Kami",
  product: "Produk",
  service: "Layanan",
  college: "Belajar",

  aboutUs: "Tentang Kami",
  rateSum: "Penjelasan Biaya",
  notices: "Pusat Pengumuman",
  helps: "Pusat Bantuan",
  verific: "Saluran Verifikasi Resmi",
  contact: "Hubungi Kami",

  fabi: "Beli Koin",
  bibi: "Perdagangan Spot",
  ganggan: "Perdagangan Margin",
  swiper: "Kontrak Abadi",
  etf: "Perdagangan ETF",
  licai: "Earn",

  apis: "Dukungan API",
  apisNew: "Dukungan API",
  addCoin: "Aplikasi List Koin",
  vips: "Hak VIP",
  downapp: "Unduh APP",
  files: "Dokumen Hukum",

  newuser: "Kamp Pelatihan Pemula BiKing",
  swiperSchool: "Akademi Kontrak",
  assistant: "Asisten Belajar",
  digitalintroduction: "Pengenalan Aset Digital",

  watchword: "Platform Perdagangan Hijau Kelas Dunia",
  meiyitian: "Setiap Hari, Jadikan Kekayaan Terjadi",
  chat: "Ruang Obrolan",
  shequncn: "Komunitas Telegram Bahasa Tionghoa",
  shequnen: "Komunitas Telegram Bahasa Inggris",
  shequnkr: "Komunitas Telegram Bahasa Korea",
};

const SIDEBAR = {
  newuser: "Pemula",
  guide: "Panduan",
  bbsq: "Komunitas Spot",
  hysq: "Komunitas Kontrak",
  gd: "Tetap",
  sq: "Tutup",
};

const banner = {
  wzwh: 'Menggunakan situs web Biking dan/atau memelihara akun Anda berarti Anda menyetujui yang telah diperbarui kami',
  sytk: 'Syarat Penggunaan',
  yszc: 'Kebijakan Privasi',
  hh: 'dan',
  cookie: 'Kebijakan CookIe',
  djgb: 'Klik "X" berarti Anda mengakui bahwa Anda telah membaca dan menyetujui ketentuan dan kebijakan di atas.',

  title: 'Platform Game dan Perdagangan Mata Uang Digital yang Beragam',
  marketTitle: 'Perdagangan Mata Uang Digital Kami Profesional',
  marketSubTitle: 'Berkomitmen untuk menyediakan layanan perdagangan derivatif aset crypto yang lebih aman dan stabil bagi pengguna',
  pathTitle: 'Asisten Perjalanan Mata Uang Digital Anda',
  pathSubTitle: 'Pilihan jutaan pengguna, platform yang dapat Anda percayai',
  jylz: '$300 Miliar',
  jyl: 'Volume Perdagangan 72 Jam',
  sxs: 'Cryptocurrency Tersedia',
  zcyh: 'Pengguna Terdaftar',
  zdjy: 'Biaya Perdagangan Minimum',
  connectTitle: 'Mengapa Memilih Kami',
  connectSubTitle: 'BiKing membantu Anda menciptakan, menambah nilai, dan menjaga kekayaan',
  advantageText1: 'Kinerja Teratas · Perdagangan Super Cepat',
  advantageSubText1: 'Didorong oleh teknologi London Stock Exchange, latensi super rendah, pencocokan super cepat',
  advantageText2: 'Perlindungan Aset · Keamanan Maksimal',
  advantageSubText2: 'BiKing mematuhi standarat CCSS, menjamin keamanan aset dan data',
  advantageText3: 'Likuiditas Tinggi · Spread Rendah',
  advantageSubText3: 'Perdagangan leverage kontrak BiKing, efisiensi super tinggi, slippage minimal',
  advantageText4: 'Layanan 24/7',
  advantageSubText4: 'Menjamin sistem beroperasi normal, menyediakan layanan pelanggan 24 jam',
  advantageText5: 'Mudah dan Nyaman Digunakan',
  advantageSubText5: 'Menyediakan berbagai sistem pesanan dan alat perdagangan, risiko dapat dikendalikan',
  advantageText6: 'Di Mana Saja · Perdagangan Aman',
  advantageSubText6: 'Platform BiKing menyediakan versi web, aplikasi seluler, koneksi API dan FIX',
  netWorkTitle: 'Pilihan Bersama 1,2 Juta Pengguna dari 26 Negara',
  netWorkSubTitle: 'Berkomitmen untuk menyediakan layanan perdagangan derivatif aset crypto yang lebih aman dan stabil bagi pengguna',
  smxz: 'Pindai untuk Mengunduh',
  fxbzj: 'Margin Risiko',
  fkbz: 'Pastikan setiap transaksi memiliki jaminan pengendalian risiko dana yang komprehensif',
  question1: '1. Perkenalan Exchange BiKing',
  questionContent1: 'BiKing Exchange adalah platform perdagangan aset digital terkemuka global yang berbasis di Singapura, memegang lisensi ganda MSB AS/Kanada, menyediakan berbagai layanan perdagangan, penyimpanan, manajemen aset digital.',
  question2: '2. Produk apa yang disediakan oleh BiKing Exchange?',
  questionContent2: 'BiKing Exchange menyediakan produk berikut: Kontrak Abadi ——Kedalaman優, pencocokan detik; Perdagangan Spot ——0 biaya, eksekusi cepat; Komunitas Salin ——Trader资深, strategi stabil; Perdagangan Bonus ——Mode unik, bonus terus menerus; Dompet Web ——Layanan one-stop terdesentralisasi',
  question3: '3. Bagaimana cara mendaftar di BiKing Exchange?',
  questionContent3: 'Anda dapat mendaftar di situs web resmi BiKing Exchange atau APP BiKing. Klik daftar, selesaikan proses pendaftaran即可 menggunakan BiKing Exchange untuk investasi dan manajemen keuangan mata uang digital.',
  question4: '4. Bagaimana cara membeli mata uang digital melalui BiKing Exchange?',
  questionContent4: 'Pembelian cepat koin BiKing Exchange mendukung berbagai metode pembayaran dan berbagai mata uang fiat, memberikan lebih banyak pilihan dan kemudahan bagi pengguna global. Terlepas dari negara atau wilayah asal pengguna, mereka dapat dengan mudah menggunakan mata uang lokal untuk membeli mata uang digital.',
  question5: '5. Bagaimana melakukan perdagangan aset digital?',
  questionContent5: 'Anda dapat memilih aset digital yang ingin diperdagangkan di BiKing Exchange, setelah masuk ke halaman perdagangan, pilih beli atau jual, masukkan jumlah dan harga perdagangan, konfirmasi perdagangan即可. Dan BiKing Exchange mendukung perdagangan berbagai aset digital, termasuk Bitcoin, Ethereum, Litecoin, Ripple, dll.',
  question6: '6. Bagaimana BiKing Exchange menjamin keamanan aset pengguna?',
  questionContent6: 'BiKing Exchange menggunakan teknologi enkripsi multi-layer untuk menjamin keamanan informasi dan aset pengguna, dan menggunakan metode penyimpanan pemisahan dompet panas dan dingin untuk memastikan keamanan aset pengguna.',
  investor: 'Dipercaya oleh 3Juta Investor Cryptocurrency',
  transaction: 'Berinvestasi, Berdagang, dan Berkembang di BIKing',
  hypt: 'Platform Perdagangan Kontrak Aset Digital Terdepan yang Aman Secara Global',
  yjpc: 'Satu Klik untuk Buka/Tutup Posisi',
  jscrj: 'Isi/Tarik Super Cepat, 60S Mulai Perdagangan Benar-benar Mewujudkan Perdagangan Zero Slippage',
  zcpt: 'Daftar & Perdagangan Dapat USDT',
  email: 'Alamat Email',
  phone: 'Nomor Telepon',
  zc: 'Daftar',
  yhjaqbz: 'Jaminan Keamanan Tingkat Bank',
  lhdmch: '0 Slippage, Pencocokan Detik',
  qthkf: 'Layanan Pelanggan 7*24 Jam',
  rmjmhb: 'Cryptocurrency Populer',
  jrsq: 'Bergabunglah dengan Komunitas Biking',
  hqzxhd: 'Dapatkan informasi aktivitas Biking terbaru dan dukungan online',
}
const navCard = {
  join: 'Join BiKing',
  hzdl: 'Mitra Agen Kerjasama BiKing币王 Menantikan Kehadiran Anda',
  jmrx: 'Hotline Keagenan: 183283232998',
  contract: 'Kontrak online',
  yxhy: 'Kontrak Kilat币王 Kontrak Ganda Kejutan Tersedia',
  jylh: 'Perdagangan Lebih Fleksibel, Pendapatan Lebih Kaya',
  usa: 'USA AND CANADA MSB',
  zmjys: 'Exchange Luar Negeri Terkenal BIKing币王 Memenangkan Banyak Lisensi Kepatuhan',
  fxpf: 'Risiko Ditanggung, Aman dan Dapat Dipercaya',
  srhy: '币王 Masuk Kontrak Hadiah 30% Emas Asli',
  hdsj: 'Waktu Aktivitas: 01 Nov 2022 00:00 hingga 01 Des 2022 00:00'
}

const choice = {
  gjyh: 'Pilihan Bersama 1,2 Juta Pengguna dari 26 Negara',
  jyfu: 'Berkomitmen untuk menyediakan layanan perdagangan derivatif aset crypto yang lebih aman dan stabil bagi pengguna',
  wsmxzwm: 'Mengapa Memilih Kami',
  jsty: 'Pengalaman Super Cepat',
  jmsj: 'Desain antarmuka perdagangan menggabungkan pengalaman operasional pengguna platform selama bertahun-tahun, proses yang jelas, operasi yang mudah, ditambah teknologi pencocokan inti memori mikro-detik, memberikan pengalaman perdagangan yang lebih nyaman dan nyaman bagi pengguna.',
  kfx: 'Mekanisme Harga Tahan Risiko',
  pthybz: 'Harga koin kontrak platform menggunakan algoritma integrasi multi-sumber indeks, memiliki kemampuan kontrol risiko yang kuat, secara efektif menghindari risiko dan kerugian pengguna yang ditimbulkan oleh fluktuasi pasar dalam berbagai kondisi pasar ekstrem.',
  zjaqbz: 'Jaminan Keamanan Dana',
  zjdt: 'Semua dinamika dana diselesaikan dengan multiple offline signature, menjamin penilaian mikro-detik, penyimpanan aset cold storage mendalam, mengawal keamanan dana pengguna secara komprehensif, memberikan kontrol risiko keamanan tingkat bank 100% untuk setiap pengguna.',
  jszc: 'Dukungan Teknologi Teratas',
  ptjstd: 'Tim teknologi platform terdiri dari para ahli teknologi blockchain teratas, menjamin pengalaman pengguna yang maksimal, memberikan dukungan teknis yang kuat untuk pengembangan dan operasi platform.',
  jcjz: 'Mekanisme Pengurangan Posisi Bertahap',
  hqbh: 'Berdasarkan perubahan kondisi pasar, secara wajar memicu mekanisme kontrol risiko perdagangan pengguna, 24 jam mengawal properti pengguna.',
  kf: 'Layanan Pelanggan 24 Jam',
  ptkf: 'Platform menggunakan sistem shift layanan pelanggan 24 jam, menangani setiap masalah yang dihadapi pengguna dengan serius.'
}

const plat = {
  ptgn: 'Fungsi Platform',
  zjms: 'Mode Bonus',
  zjjs: 'Mode Bonus adalah fitur kontrak baru yang pertama kali diluncurkan oleh tim币王 untuk pengguna kontrak di seluruh jaringan. Proses operasi mode bonus konsisten dengan kontrak real, bagian keuntungan yang diperoleh dari pembukaan posisi dapat ditransfer ke akun kontrak,用于 melanjutkan pembukaan posisi atau penarikan langsung, cara memperoleh termasuk: pengembalian biaya real-time, airdrop aktivitas, menyelesaikan tugas, dll.',
  zcms: 'Mode Cross Margin',
  zcjs: 'Dalam mode cross margin, margin semua posisi dan keuntungan/kerugian mengambang saling terhubung, dan semua aset akun termasuk margin pembukaan posisi berfungsi sebagai margin mengambang. Mode cross margin memiliki kemampuan kontrol risiko yang kuat, tetapi同样 ketika fluktuasi pasar剧烈, mudah melebihi ekspektasi kerugian.',
  zucms: 'Mode Isolated Margin',
  zucjs: 'Dalam mode isolated margin, setiap order independen, menghitung keuntungan dan kerugian secara independen berdasarkan harga pembukaan masing-masing posisi. Setelah modal order tunggal (atau disebut margin) rugi hingga titik stop loss maksimum, akan dilikuidasi paksa. Saat untung hingga titik take profit maksimum, tutup posisi otomatis. Ketika ada order posisi atau order rencana dalam mode isolated margin, tidak dapat beralih mode isolated margin untuk membuka posisi.',
  gdgn: 'Fungsi Salin',
  gdjs: 'Setelah mengaktifkan fungsi salin, semua perilaku pembukaan dan penutupan posisi trader yang disalin akan disinkronkan dan dieksekusi, hanya tidak dapat diselesaikan ketika saldo akun tidak mencukupi atau melebihi batas posisi. Jika tidak dibatalkan secara manual, fungsi salin akan terus aktif.',
  bfpc: 'Tutup Posisi Sebagian',
  bfjs: 'Ketika memegang sejumlah posisi long atau short, Anda dapat secara bebas memilih jumlah penutupan posisi berdasarkan perubahan pasar dan situasi keuntungan/kerugian. Pada saat yang sama, jumlah keuntungan/kerugian order posisi juga akan diselesaikan secara proporsional berdasarkan rasio jumlah penutupan posisi dengan total margin. Setelah penutupan posisi, keuntungan mengambang tidak berubah.',
  fxkc: 'Buka Posisi Berlawanan',
  fxjs: 'Sistem akan secara otomatis membantu Anda menutup posisi yang saat ini dipilih dengan harga pasar terbaik, dan membuka posisi dengan arah yang berlawanan dan jumlah posisi yang sama dengan harga pasar terbaik, untuk menghindari kehilangan tren pembalikan atau tidak sempat membuka posisi ketika tren pembalikan datang.',
  zjbzj: 'Tambahkan Margin',
  zjbzjjs: 'Ketika memegang sejumlah posisi long atau short, Anda dapat menambahkan margin berdasarkan parameter posisi saat ini. Setelah menambahkan margin, koefisien posisi akan dihitung dengan formula pembobotan berdasarkan parameter posisi masing-masing saat pembukaan dan penambahan margin.'
}

const risk = {
  fxbzj: 'Margin Risiko',
  fxbz: 'Pastikan setiap transaksi memiliki jaminan pengendalian risiko dana yang komprehensif'
}

const license = {
  license: '币王 Memenangkan Lisensi Keuangan MSB',
  hgyy: 'Operasi Kepatuhan, Tata Letak Global',
  login: 'Login',
  download: 'Pindai Kode QR untuk Mengunduh币王',
  support: 'Dukungan',
  jsjy: 'Perdagangan Kapan Saja, Eksekusi Super Cepat',
  ljxz: 'Unduh Segera Aplikasi BiKing'
}

const footer = {
  yhyh: 'Paling Ramah Pengguna',
  jypt: 'Platform Perdagangan Kontrak',
  yhzc: 'Dukungan Pengguna',
  flsm: 'Penjelasan Biaya',
  ggzx: 'Pusat Pengumuman',
  yhxz: 'Pemberitahuan Pengguna',
  tksm: 'Penjelasan Ketentuan',
  fxzs: 'Peringatan Risiko',
  xylb: 'Daftar Perjanjian',
  gywm: 'Tentang Kami',
  gy: 'Tentang',
  lxwm: 'Hubungi Kami',
  appxz: 'Unduh App',
  callus: 'Berlangganan BIKING Genesis',
  zwzxxx: 'Kuasai berita, wawasan, dan fluktuasi harga terbaru',
  zc: 'Daftar',
  email: 'Alamat Email',
  callingus: 'Hubungi Kami',
  bqsy: 'Hak Cipta',
  tips: 'Pemberitahuan: Investasi mengandung risiko, masuk ke pasar需要 berhati-hati'
}

const card = {
  title: 'Mengapa Kami Platform Kontrak Paling Ramah',
  text: 'BiKing membantu Anda menciptakan, menambah nilai, dan menjaga kekayaan',
  djxn: 'Pengembalian Biaya',
  jsqd: 'Pengembalian biaya 100% real-time secara signifikan mengurangi biaya trading, meningkatkan peluang profit',
  zcbz: 'Isi/Tarik Super Cepat',
  cssbz: 'Isi/Tarik super cepat, isi/tarik lancar tanpa lag, menjamin keamanan dana pengguna, tidak melewatkan setiap peluang trading',
  gld: 'Mudah dan Nyaman Digunakan',
  zxhd: 'Pendaftaran & pembukaan posisi hanya需 10 detik, sistem keamanan unik melindungi privasi pengguna, proses pendaftaran lebih sederhana',
  qthfw: 'Layanan 24/7',
  kffw: 'Pengalaman interaksi yang nyaman dan lancar, mekanisme margin gold standard, layanan pelanggan online 24 jam, masalah trading dijawab real-time',
  bjyy: 'Mudah dan Nyaman Digunakan',
  fxkk: 'Menyediakan berbagai sistem pesanan dan alat perdagangan, risiko dapat dikendalikan',
  axjy: 'Di Mana Saja · Perdagangan Aman',
  bkms: 'Platform BiKing menyediakan versi web, aplikasi seluler, koneksi API dan FIX'
}

const news = {
  title: 'Berita & Wawasan',
  text: 'Pelajari berita dan karakteristik bisnis dari exchange cryptocurrency terkemuka dunia',
  sy: 'Wawasan',
  ltitle: 'Bisakah Bitcoin Mengatasi Tantangan Unik Pasar Berkembang?',
  ldesc: 'Artikel ini awalnya terlihat setara dengan Cointelegraph. Seiring Blockchain Economy Istanbul Summit berfokus pada pengembangan pasar berkembang, popularitas Bitcoin terus didorong oleh permintaan kasus?…',
  more: 'Pelajari Lebih Lanjut',
  xwfbs1: 'Ruang Pers',
  rdesc1: 'Exchange Aset Digital BiKng Mensponsori Blockchain Economy Istanbul Summit 2022',
  xwfbs2: 'Ruang Pers',
  rdesc2: 'Exchange Aset Digital BiKng Mensponsori Blockchain Economy Istanbul Summit 2022',
}

const info = {
  hzhb: 'Mitra Platform Perdagangan Otomatis',
  qsjy: 'Gunakan Trading Bot untuk Perdagangan Mudah di BiKing',
  quadency: 'QUADENCY',
  clpt: 'Platform Strategi Perdagangan Otomatis Profesional',
  stacked: 'Stacked',
  glcf: 'Pengguna dapat menggunakan Stacked untuk berinvestasi dalam indeks crypto. Melakukan perdagangan otomatis dan mengelola kekayaan'
}
const menu = {
  Realtimequotes: 'Kutipan waktu nyata hanya untuk referensi; silakan lihat harga di halaman penyedia layanan pihak ketiga.',

Realtimequotes1: 'Batas Transaksi Tunggal',

Realtimequotes2: 'Harga Referensi',

Realtimequotes3: 'Pembelian',

Realtimequotes5: 'Silakan Masukkan Jumlah Pembelian',

Realtimequotes6: 'Maksimum',

Realtimequotes7: 'Melebihi Batas Maksimum',

Realtimequotes8: 'Kuantitas',

Realtimequotes9: 'Biaya Transaksi',

Realtimequotes10: 'Metode Pembayaran',

Realtimequotes11: 'Waktu Kedatangan'
,
Realtimequotes12: '10-20 menit setelah pembayaran berhasil',

Realtimequotes13: 'Konfirmasi Pembelian',

Realtimequotes14: 'Langkah Pembelian',

Realtimequotes15: 'Pilih mata uang kripto yang akan dibeli, mata uang fiat yang akan dibayar, dan penyedia layanan nama',

Realtimequotes16:'Masukkan jumlah pembelian, isi informasi di situs web penyedia layanan pihak ketiga, dan selesaikan pembayaran',
Realtimequotes17:'Lihat mata uang kripto yang dibeli di riwayat deposit aset BiKing, dan lihat detail pesanan di situs web penyedia layanan.',

Realtimequotes18:'Anda akan dialihkan ke {XXXXX} untuk melakukan pembelian.',

Realtimequotes24:'Pengingat Ramah',

Realtimequotes19:'{XXXXX} adalah platform perdagangan mata uang fiat dan mata uang kripto yang dioperasikan secara independen oleh pihak ketiga. Semua layanan terkait disediakan oleh {XXXXX}.',

Realtimequotes20:'Harga referensi sudah termasuk biaya platform. Harga transaksi aktual bergantung pada harga di situs web resmi {XXXXX}.',

Realtimequotes21:'BiKing tidak bertanggung jawab atas kerugian atau kerusakan apa pun yang diderita akibat penggunaan layanan ini.',

Realtimequotes22: 'Dimengerti, lanjutkan sekarang.',

Realtimequotes23: 'Jumlah Pembelian',

Realtimequotes25: 'Transaksi Pihak Ketiga',

Realtimequotes26: 'Harap lengkapi informasi email Anda terlebih dahulu.',

Realtimequotes27: 'Lengkapi sekarang.',
  creditCardOrder: 'Pesanan Pembayaran',
  ptmb: 'C2C',
  kjmb: 'Beli Koin Kilat',
  xykmb: 'Beli Koin dengan Kartu Kredit',
  order: 'Pesanan',
  userOrder: 'Pesanan Pengguna',
  merchantOrder: 'Pesanan Merchant',
  quickOrder: 'Pesanan Kilat',
  merchant:'Merchant',
  asMerchant:'Menjadi Merchant',
  advertisingManage: 'Manajemen Iklan',
  financialStatements: 'Laporan Keuangan',
  messageCenter: 'Pusat Pesan',
  more: 'Lainnya',
  paymentSettings: 'Pengaturan Penerimaan Pembayaran',
  publish: 'Terbitkan Iklan',
  overview: 'Ikhtisar',
  aqzx: 'Pusat Keamanan',
  phsz: 'Pengaturan Preferensi',
  hykhj: 'Pesta Kontrak, Era Baru Perdagangan',
  xszn: 'Panduan Pemula',
  bwyjy: 'Institut Riset币王',
  bwsq: 'Komunitas币王',
  yhxz: 'Pemberitahuan Pengguna',
  bwysp: 'Produk Turunan币王',
  jyxz: 'Pemberitahuan Perdagangan OTC'
}
const otc = {
  bjgq: 'Kutipan ini telah kedaluwarsa, harap dapatkan kutipan lagi',
  gxbj: 'Perbarui Kutipan',
  zxkdh: 'Minimum dapat ditukar {min} {symbol}',
  zdkdh: 'Maksimum dapat ditukar {max} {symbol}',
  Available: 'Saldo Tersedia',
  Unknown: 'Tidak Diketahui',
  qxgz: 'Aturan Pembatalan: Pembeli yang membatalkan累计 200 kali dalam sehari, akan dibatasi fungsi pembelian pada hari itu.',
  xncs: 'Menjual kepada Anda',
  qxzzffs: 'Silakan pilih metode pembayaran',
  qdqx: 'Konfirmasi Pembatalan',
  wzxx: 'Saya Akan Pikirkan Lagi',
  msk: 'Metode Pembayaran Pembeli',
  zhmc: 'Nama Akun',
  zhxq: 'Detail Akun',
  xzhb: 'Pilih Mata Uang',
  
  buyer: 'Pembeli',
  seller: 'Penjual',
  goSet: 'Pergi Tambahkan',
  addPayWayTitle: 'Tambahkan Metode Pembayaran',
  addPayWay: 'Anda perlu menambahkan atau mengaktifkan setidaknya satu metode pembayaran untuk {type} mata uang digital',
  supportPayWay: 'Anda perlu menambahkan dan mengaktifkan metode pembayaran yang didukung {type}',
  top: 'Sematkan di Atas',
  marginTips: 'Anda telah membayar margin {baseMarginPaid} USDT,仍需 membayar tidak kurang dari {needMargin} USDT',
  eyqx: 'Membatalkan banding 3 kali sehari akan membatasi inisiasi banding,同时 jika itu是 pembatalan jahat, setelah diselidiki akun akan dibekukan, harap berhati-hati!',
  qdbzgm: 'Yakin tidak ingin membeli lagi?',
  qxbtk: 'Setelah membatalkan pesanan, tidak akan ada pengembalian dana. Jika Anda telah membayar, jangan batalkan pesanan.',
  yzjbzj: 'Merchant普通 telah menambahkan margin',
  xbjjcbzj: 'Perlu melunasi margin dasar',
  jg: 'Harga',
  zxjgxd: 'Pesan dengan harga terbaru saat ini',
  je: 'Jumlah',

  ccxe: 'Melebihi Batas',
  yebz: 'Saldo Tidak Cukup',
  qxsm: 'Harap Verifikasi Identitas Terlebih Dahulu',

  dfb: 'Menunggu Pelepasan Koin',
  jywc: 'Transaksi Selesai',
  buy: 'Beli',
  sell: 'Jual',
  coin: 'Mata Uang',
  allCoin: 'Semua Mata Uang',
  frenchCurrency: 'Mata Uang Fiat',
  payWay: 'Metode Pembayaran',
  all: 'Semua',
  bankCard: 'Kartu Bank',
  zfb: 'Alipay',
  wx: 'WeChat',
  search: 'Cari',
  merchant: 'Merchant (Pesanan Selesai 30 Hari/Tingkat Penyelesaian 30 Hari)',
  turnover: 'Volume',
  completionRate: '% Tingkat Penyelesaian',
  quotaOrNumber:'Jumlah/Batas',
  number: 'Jumlah',
  quota: 'Batas',
  price: 'Harga Satuan',
  paymentMethod: 'Metode Pembayaran',
  trade: 'Perdagangan',
  handlingFee: '0 Biaya',
  buyUsdt: 'Beli USDT',
  sellBtc: 'Jual USDT',
  theRemainingAmount: 'Jumlah Tersisa',
  userRealName: 'Nama Asli Pengguna',
  businessMessage: 'Pesan Merchant',
  wantPay: 'Saya Ingin Bayar',
  wantSell: 'Saya Ingin Jual',
  receive: 'Saya Akan Menerima',
  password: 'Kata Sandi',
  pleaseEnterPassword: 'Masukkan Kata Sandi',
  cancel: 'Batal',
  buyUSDT: 'Beli USDT',
  sellUSDT: 'Jual USDT',
  Paymentchannel :'Saluran Pembayaran (Harap mengacu pada汇率 yang ditetapkan oleh penyedia layanan.)',
  lumpSum: 'Jumlah Total',
  agree: 'Jika Anda setuju untuk melakukan transaksi C2C dengan币王, itu berarti Anda menerima',
  mzsm: 'Pernyataan Penolakan Hukum Perdagangan C2C币王',
  quit: 'Keluar',
  confirm: 'Konfirmasi',
  orderDetail: 'Detail Pesanan',
  limitExceeded: 'Melebihi Batas',
  quantityRemaining: 'Jumlah Tersisa Tidak Cukup',

  cryptoTitle: 'Hanya需 beberapa langkah untuk membeli USDT dengan mudah',
  cryptoSubTitle: 'Platform Perdagangan Kontrak Aset Digital Terdepan yang Aman Secara Global',
  availableBalance: 'Saldo Tersedia',
  sellAll: 'Jual Semua',
  fundsTransfer: 'Transfer Dana',
  threeStep: 'Beli Koin Hanya需 Tiga Langkah',
  advantage: 'Keuntungan Memilih币王 untuk Membeli/Menjual Cryptocurrency',
  commonQuestion: 'Pertanyaan Umum',
  otc_title: 'Gunakan C2C 0 Biaya untuk Beli/Jual Cryptocurrency',
  otc_title1: 'Perdagangan dengan aman dan mudah dengan biaya nol di BiKing. Segera交易 USDT melalui transfer bank, kartu kredit, dan banyak metode pembayaran lainnya',
  commonQuestion1: 'Apa itu perdagangan cryptocurrency P2P?',
  commonQuestion2: 'Berapa biaya perdagangan P2P?',
  commonQuestion3: 'Apa itu merchant di BiKing P2P?',
  commonQuestion4: 'Apakah merchant BiKing P2P menghasilkan untung?',
  commonQuestion5: 'Bagaimana menghindari penipuan P2P?',
  commonQuestion1_desc: 'Crypto P2P mengacu pada perdagangan cryptocurrency peer-to-peer, di mana Anda dapat memperdagangkan cryptocurrency langsung satu sama lain tanpa memerlukan perantara seperti exchange terpusat.',
  commonQuestion2_desc: 'Biaya perdagangan P2P dapat sangat bervariasi tergantung pada platform, cryptocurrency tertentu, dan kemacetan jaringan pada saat perdagangan. Namun, BiKing P2P mengenakan biaya nol untuk perdagangan cryptocurrency, tanpa perantara.',
  commonQuestion3_desc: 'Merchant di BiKing P2P adalah pengguna terverifikasi yang dapat memposting iklan perdagangan dan melakukan transaksi dengan pengguna lain di platform.',
  commonQuestion4_desc: 'Profitabilitas merchant BiKing P2P tergantung pada berbagai faktor, termasuk strategi trading merchant, frekuensi trading, spread beli/jual, dan kondisi pasar secara keseluruhan.',
  commonQuestion5_desc: 'Untuk melindungi dari penipuan P2P, verifikasi identitas pihak lain, gunakan platform yang aman, batasi berbagi data pribadi atau keuangan, dan gunakan metode pembayaran yang dapat dilacak.',
  register: 'Daftar',
  registerByPhone: 'Daftar dengan Email atau Nomor Telepon',
  authentication: 'Verifikasi Identitas',
  authenticationId: 'Selesaikan verifikasi identitas, hanya需 dokumen ID',
  buyCoins: 'Beli Koin',
  buyCoinsByCard: 'Beli Koin dengan Kartu Kredit/Debit atau Transfer Bank',
  fast: 'Cepat dan Mudah',
  easyUse: 'Operasi beli koin sederhana',
  fastPayment: 'Hanya需 beberapa menit untuk sampai dengan cepat.',
  multiplePayment: 'Berbagai Metode Pembayaran',
  platformSupports:'Platform mendukung berbagai metode pembayaran',
  flexibleConvenient: 'Memberikan fleksibilitas dan kenyamanan yang lebih besar bagi pengguna.',
  safeReliable: 'Aman dan Terpercaya',
  measure: 'Mengadopsi multiple teknologi dan langkah-langkah keamanan',
  informationSecurity: 'Memastikan keamanan dana, keamanan informasi pengguna.',
  questionTitle1: '1. Perkenalan Exchange BiKing',
  questionSubTitle1: 'BiKing Exchange adalah platform perdagangan aset digital terkemuka global yang berbasis di Singapura, memegang lisensi ganda MSB AS/Kanada, menyediakan berbagai layanan perdagangan, penyimpanan, manajemen aset digital.',
  questionTitle2: '2. Produk apa yang disediakan oleh BiKing Exchange?',
  questionSubTitle2: 'BiKing Exchange menyediakan produk berikut: Kontrak Abadi ——Kedalaman優, pencocokan detik; Perdagangan Spot ——0 biaya, eksekusi cepat; Komunitas Salin ——Trader资深, strategi stabil; Perdagangan Bonus ——Mode unik, bonus terus menerus; Dompet Web ——Layanan one-stop terdesentralisasi',
  questionTitle3: '3. Bagaimana cara mendaftar di BiKing Exchange?',
  questionSubTitle3: 'Anda dapat mendaftar di situs web resmi BiKing Exchange atau APP BiKing. Klik daftar, selesaikan proses pendaftaran即可 menggunakan BiKing Exchange untuk investasi dan manajemen keuangan mata uang digital.',
  questionTitle4: '4. Bagaimana cara membeli mata uang digital melalui BiKing Exchange?',
  questionSubTitle4: 'Pembelian cepat koin BiKing Exchange mendukung berbagai metode pembayaran dan berbagai mata uang fiat, memberikan lebih banyak pilihan dan kemudahan bagi pengguna global. Terlepas dari negara atau wilayah asal pengguna, mereka dapat dengan mudah menggunakan mata uang lokal untuk membeli mata uang digital.',
  questionTitle5: '5. Bagaimana melakukan perdagangan aset digital?',
  questionSubTitle5: 'Anda dapat memilih aset digital yang ingin diperdagangkan di BiKing Exchange, setelah masuk ke halaman perdagangan, pilih beli atau jual, masukkan jumlah dan harga perdagangan, konfirmasi perdagangan即可. Dan BiKing Exchange mendukung perdagangan berbagai aset digital, termasuk Bitcoin, Ethereum, Litecoin, Ripple, dll.',
  questionTitle6: '6. Bagaimana BiKing Exchange menjamin keamanan aset pengguna?',
  questionSubTitle6: 'BiKing Exchange menggunakan teknologi enkripsi multi-layer untuk menjamin keamanan informasi dan aset pengguna, dan menggunakan metode penyimpanan pemisahan dompet panas dan dingin untuk memastikan keamanan aset pengguna.',
  
  orderType: 'Jenis Pesanan',
  orderStatus: 'Status Pesanan',
  to: 'Hingga',
  startTime: 'Tanggal Mulai',
  endTime: 'Tanggal Berakhir',
  orderNo: 'Nomor Pesanan',
  status: 'Status',
  totalPrice: 'Harga Total',
  numberOrFee: 'Jumlah Transaksi/Biaya',
  tradingPartners: 'Rekan Transaksi',
  time: 'Waktu',
  operate: 'Operasi',
  details: 'Detail',
  noPay: 'Menunggu Pembayaran',
  payed: 'Telah Dibayar',
  finish: 'Telah Selesai',
  canceled: 'Dibatalkan',
  complaint: 'Dalam Banding',
  legalCurrency: 'Jumlah Mata Uang Fiat',
  virtualCurrency: 'Mata Uang Digital',
  virtualCurrencyAddress: 'Alamat Penerimaan',
  paymenttype: 'Jenis Pembayaran',
  creatTime: 'Waktu Pembuatan',
  success: 'Berhasil',
  pending: 'Sedang Diproses',
  awaiting: 'Menunggu Konfirmasi',
  declined: 'Gagal',

  mjskfs: 'Metode Pembayaran Penjual',
  mjfkfs: 'Metode Pembayaran Pembeli',
  toPay: 'Pergi Bayar',
  ddzdqx: 'Jika Anda belum memilih metode pembayaran dalam {payTime}, pesanan akan dibatalkan secara otomatis',
  paying: 'Pihak lain sedang membayar...',
  fkckh: 'Nomor Referensi Pembayaran：',
  dfwfkqx: 'Jika pihak lain belum membayar dalam {payTime}, pesanan akan dibatalkan secara otomatis',
  ddqxwfck: 'Pesanan telah dibatalkan, tidak dapat melihat informasi pembayaran',
  ddqxckh: 'Pesanan telah dibatalkan, nomor referensi pembayaran:',
  ssz: 'Dalam banding, harap tunggu, nomor referensi pembayaran:',
  qxss: 'Batalkan Banding',
  xzfkfs: 'Metode pembayaran yang Anda pilih',
  ddywc: 'Pesanan Telah Selesai',
  ss: 'Banding',
  wcfqss: '* Dapat mengajukan banding 1 menit setelah pesanan selesai',
  bnfqss: '* Tidak dapat lagi mengajukan banding setelah {time} jam penyelesaian',
  zxkf: '* Setelah pembelian OTC, perlu menunggu T+1 hari untuk penarikan. Jika ada pertanyaan, silakan hubungi layanan pelanggan.',
  sjyjn: 'Merchant telah membayar deposit {deposit} {depositName}',
  wen1: '1. Kapan saya akan menerima pembayaran?',
  da1: 'Anda akan menerima pemberitahuan setelah pihak lain menyelesaikan pembayaran.',
  wen2: '2. Pembeli memesan tetapi tidak membayar, bagaimana menanganinya?',
  da2: 'Penjual tidak dapat membatalkan pesanan, tetapi jika waktu tunggu terlalu lama, Anda dapat mengajukan banding, tim layanan pelanggan akan menyelesaikannya untuk Anda.',
  wen3: '3. Apa dampaknya jika tidak melepaskan aset digital tepat waktu?',
  da3: 'Setelah menerima pembayaran, jika Anda tidak mengonfirmasi penerimaan tepat waktu, dapat menyebabkan pembeli mengajukan banding, memengaruhi reputasi Anda di platform;同时, aset Anda akan tetap dibekukan di dompet platform Anda sebelum diproses.',
  wen4: '4. Hal yang perlu diperhatikan untuk penerimaan pembayaran',
  da4: '1) Harap berulang kali memastikan apakah Anda benar-benar menerima pembayaran dari pihak lain, jangan percaya alasan apa pun yang mendesak untuk melepaskan koin, konfirmasi收到 pembayaran sebelum mengklik \"Konfirmasi Penerimaan\", hindari kerugian aset digital!<br/>2) Ketika akun bank transfer pembeli tidak sesuai dengan nama asli akun platform, harap perhatikan risiko penerimaan pembayaran, jika ada pertanyaan, segera ajukan banding.',
  qzgdsjnzf: 'Menunggu pembayaran, harap bayar {totalAmounts} {fiatCurrency} kepada {associatedAdMerchantNickname} dalam {payTime}, nomor referensi pembayaran：',
  nxdfgm: 'Anda membeli {amount_s} {coinsName} dari {associatedAdMerchantNickname} ({realName})',
  dfxngm: '{userNickName} ({realName}) membeli {amount_s} {coinsName} dari Anda',
  nxdfcs: 'Anda menjual {amount_s} {coinsName} kepada {associatedAdMerchantNickname} ({realName})',
  dfxncs: '{userNickName} (${realName}) menjual {amount_s} {coinsName} kepada Anda',
  payed: 'Telah Dibayar',
  dddffx: 'Menunggu pihak lain melepaskan……',
  njhdq: 'Anda akan mendapatkan {quantity}{coinsName}',
  qxdd: 'Batalkan Pesanan',
  kfqss: 'Setelah {complaintPayed} menit pembayaran, jika pihak lain仍未 melepaskan koin, dapat mengajukan banding',
  yfkfkckh: 'Pihak lain telah membayar, nomor referensi pembayaran:',
  qjkqrsk: 'Harap konfirmasi penerimaan secepatnya',
  ddnsk: 'Menunggu Anda menerima pembayaran',
  zfje: 'Jumlah Pembayaran',
  skzh: 'Akun Penerima:',
  fkzhxm: 'Nama Akun Pembayar:',
  qdskh: '* Harap pastikan Anda telah menerima pembayaran dalam alat pembayaran Anda sendiri sebelum mengonfirmasi',
  fbl: 'Lepaskan Koin',
  dfyqrfk: '* Pihak lain telah mengonfirmasi pembayaran, jika仍未 menerima pembayaran aktual setelah {complaintPayed} menit, baru dapat mengajukan banding',
  jkcssk: '* Setelah lebih dari 24 jam pihak lain mengonfirmasi pembayaran, kami tidak dapat lagi mengajukan banding, harap segera periksa dan konfirmasi penerimaan',
  qrfb: 'Konfirmasi Pelepasan Koin',
  qwbqr: 'Harap pastikan Anda telah menerima pembayaran untuk pesanan saat ini dan mengonfirmasi jumlahnya benar sebelum melepaskan koin',
  wyqrskzq: 'Saya konfirmasi telah menerima pembayaran dan jumlahnya benar',
  tjssyy: 'Harap kirim alasan banding',
  srssyy: 'Masukkan alasan banding',
  sctpxt: 'Unggah Gambar (Opsional)',
  upload: 'Unggah',
  zdscsz: '* Maksimal dapat mengunggah tiga gambar, mendukung format jpeg, jpg, png, harap pastikan小于 3Mb',
  sstj: 'Kirim',
  qrfk: 'Konfirmasi Pembayaran',
  fkje: 'Jumlah Pembayaran',
  sdzz: '*Platform tidak mendukung pemotongan otomatis, harap transfer sendiri dari akun Anda sendiri ke akun di atas, setelah transfer selesai harap klik bayar. Jika transfer已 dilakukan tetapi tombol bayar未 diklik, kerugian yang ditimbulkan akan ditanggung sendiri',
  bzts: '*Harap jangan cantumkan informasi seperti BTC, USDT, BiKing saat transfer,否则 penjual dapat menolak',
  wfk: 'Belum Dibayar',
  w: 'Saya',
  srxxfs: 'Masukkan informasi, tekan enter untuk mengirim',
  dan: 'Pesanan',
  bnch: 'Tidak dapat menambahkan metode pembayaran dengan jenis yang sama',
 sd:'Tukar Kilat',
 from:'Bayar',
 to:'Dapatkan',
 rate:'Rasio Konversi',
 successful:'Tukar Berhasil',
 fees:'Biaya',
 slippage:'Slippage',
 standards:'Standar Pengenaan Biaya',
 transactionamount:'{num} dari jumlah transaksi',
 confirm:'Konfirmasi Penukaran',
 records:'Semua Catatan Tukar Kilat',
 tocurrency:'Koin yang Dikonsumsi',
 consumption:'Jumlah Konsumsi',
 Getcurrency:'Koin yang Didapat',
 GetQuantity:'Jumlah yang Didapat',
 ExchangeStatus:'Status Penukaran',
 Exchangetime:'Waktu Penukaran',
 Youwillconsume:'Anda akan mengonsumsi',
 YouwillGET:'Anda akan mendapatkan',
 Updatequote:'Perbarui Kutipan',
 Failed:'Tukar Gagal',
 Consumption:'Saluran Konsumsi',
 Completed:'Telah Selesai',
 chaeckrecords:'Lihat Semua Catatan Tukar Kilat》',
Converted:'Anda berhasil menukar {aaa} menjadi {bbb}',
recommend:'Rekomendasi',
  wcsj: "Waktu Penyelesaian"
}
const otcMerchant = {
  bzj: 'Margin',
  mmggs: 'Jumlah Iklan Beli/Jual',
  bx: 'Tidak Terbatas',
  ggzed: 'Total Kuota Iklan',
  kzjgged: 'Kuota Iklan yang Dapat Ditambahkan',
  zjbzjbs: 'Kelipatan Tambahan Margin',
  tbzss: 'Tampilkan 10 secara sinkron',

  tjsjsqb: 'Kirim Aplikasi Merchant',
  wcgjkycrz: 'Selesaikan Verifikasi KYC Lanjutan',
  ynlx: 'Setelah mengirim formulir, spesialis OTC akan menghubungi Anda sesegera mungkin',

  zbzl: 'Siapkan Dokumen',
  kssh: 'Verifikasi Cepat',
  
  h1: 'Perdagangan Cerdas',
  h2: 'Jadi Ahli Perdagangan C2C',
  h3: 'Akan Menjadi Merchant Terverifikasi',
  sjqy: 'Hak Merchant',
  c2cjy: 'Selain perdagangan C2C <span>0 biaya</span>, kami juga menyediakan lebih banyak hak yang beragam untuk merchant',
  fbq: 'Area Fiat Anda',
  ptsj: 'Merchant普通',
  xsqy: 'Jadilah merchant terverifikasi, nikmati lebih banyak hak',
  wtd: 'Dapat memposting order委托 setelah aplikasi berhasil',
  xjn: 'Perlu membayar deposit {deposit}',
  ljsq: 'Ajukan Sekarang',
  cwptsj: 'Anda telah menjadi merchant普通',
  cwrzsj: 'Anda telah menjadi merchant terverifikasi',
  rzsj: 'Merchant Terverifikasi',
  xrd: 'Menikmati tingkat kepercayaan tertinggi di pasar perdagangan',
  nbyq: 'Hanya dengan undangan internal Biking',
  rzbs: 'Identifikasi merchant terverifikasi yang lebih terhormat',
  pmq: 'Mendapatkan hak prioritas peringkat',
  kffw: 'Menikmati layanan pelanggan 1-on-1',
  sjxy: 'Perjanjian OTC{level}',
  xsjc: 'Tutorial Pemula',
  jygz: 'Aturan Perdagangan',
  close: 'Tutup',
  submited: 'Saya Telah Mengirimkan',
  submitSuccess: 'Pengajuan Berhasil',

  sqsj: 'Ajukan Menjadi Merchant',
  fwxy: 'Perjanjian Layanan Merchant Situs Web币王网',
  xyb: '币王网 adalah platform khusus bagi pengguna untuk melakukan perdagangan aset digital dan menyediakan layanan terkait. Untuk kemudahan ekspresi dalam perjanjian ini, perusahaan dan situs web ini bersama-sama disebut sebagai \"kami\" atau sebutan orang pertama lainnya. Selama自然人 atau subjek lain yang mendaftar dan login ke situs web ini adalah pengguna situs web ini, untuk kemudahan ekspresi dalam perjanjian ini, berikut ini menggunakan \"Anda\" atau sebutan orang kedua lainnya. Untuk kemudahan ekspresi dalam perjanjian ini, kami dan Anda bersama-sama disebut sebagai \"pihak\", dan kami atau Anda sendiri disebut sebagai \"satu pihak\".',
  ptsm: 'Pernyataan Platform:',
  p1: '1. Situs web ini hanya sebagai tempat untuk menyediakan informasi perdagangan aset digital, memberikan negosiasi, perdagangan untuk perdagangan aset digital, situs web ini tidak berpartisipasi dalam perdagangan aset digital substantif apa pun, oleh karena itu para pihak dalam perdagangan harus secara hati-hati menilai dan menentukan keaslian, legalitas, dan keefektifan aset digital dan/atau informasi terkait, dan menanggung tanggung jawab dan kerugian yang diakibatkannya sendiri.',
  p2: '2. Semua pendapat, berita, diskusi, analisis, harga, saran, dan informasi lainnya dari situs web ini adalah komentar pasar umum dan tidak构成 saran investasi. Kami tidak menanggung kerugian langsung atau tidak langsung yang timbul dari ketergantungan pada informasi tersebut, termasuk但不限于 kerugian keuntungan apa pun.',
  p3: '3. Konten situs web ini dapat berubah sewaktu-waktu tanpa pemberitahuan terpisah, kami telah mengambil langkah-langkah yang wajar untuk memastikan keakuratan informasi situs web, tetapi tidak dapat menjamin tingkat keakuratannya, juga tidak akan menanggung kerugian langsung atau tidak langsung yang timbul dari informasi di situs web ini atau kegagalan untuk terhubung ke internet, mengirim atau menerima pemberitahuan dan informasi yang延误 atau gagal.',
  p4: '4. Menggunakan sistem perdagangan bentuk internet juga mengandung risiko, termasuk但不限于 kegagalan perangkat lunak, perangkat keras, dan koneksi internet. Karena kami tidak dapat mengontrol keandalan dan ketersediaan internet, kami tidak akan bertanggung jawab atas distorsi, penundaan, dan kegagalan koneksi.',
  p5: '5. Dilarang menggunakan situs web ini untuk melakukan segala kegiatan perdagangan ilegal atau perilaku ilegal seperti pencucian uang, penyelundupan, suap komersial, jika发现 kegiatan perdagangan ilegal atau perilaku ilegal, situs ini akan mengambil berbagai cara yang dapat digunakan, termasuk但不限于 membekukan akun, memberitahu otoritas terkait, kami tidak menanggung semua tanggung jawab yang timbul dan保留 hak untuk menuntut pihak terkait.',
  p6: '6. Dilarang menggunakan situs web ini untuk melakukan segala kegiatan perdagangan tidak etis seperti manipulasi pasar, perdagangan tidak adil, jika发现 peristiwa seperti itu, situs web ini akan mengambil tindakan perlindungan preventif seperti peringatan, pembatasan perdagangan, penutupan akun untuk semua perilaku tidak etis seperti manipulasi harga, pengaruh jahat pada sistem perdagangan, kami tidak menanggung semua tanggung jawab yang timbul dan保留 hak untuk menuntut pihak terkait.',
  p7: 'Pada saat Anda menyetujui perjanjian layanan币王网, itu dianggap Anda telah menyetujui semua konten pernyataan platform. Perjanjian ini ditutup bersama oleh Anda dan operator币王网, perjanjian ini memiliki效力 kontrak lengkap.',
  zcbzj: 'Pasal 1: Margin Aset',
  p8: '1. Setelah merchant lulus审查 KYC dan anti-pencucian uang platform, platform ini akan meminta merchant untuk menyetorkan sejumlah margin dalam akun platform mereka, untuk menjamin keamanan dan kelancaran perdagangan mereka di platform.',
  p9: '2. Jumlah margin spesifik akan ditampilkan dalam aset fiat merchant di platform ini, dan juga akan ditampilkan kepada pengguna selama proses perdagangan.',
  p10: '3. Jika terjadi situasi berikut, platform berhak untuk melakukan penahanan dll pada margin merchant, margin mereka akan ditahan ≥1 bulan, jika dipastikan menyebabkan kerugian pada platform dan pengguna,后续 akan memotong margin secara proporsional.',
  p11: '1) Merchant terlibat sengketa selama proses perdagangan, dan merchant diputuskan harus bertanggung jawab dan履行 kewajiban相应, tetapi merchant tidak bekerja sama;',
  p12: '2) Merchant melakukan perdagangan dengan akun yang belum terverifikasi identitas di platform ini;',
  p13: '3) Merchant menggunakan platform ini untuk melakukan kegiatan ilegal apa pun;',
  p14: '4) Merchant melanggar perjanjian ini atau dokumen hukum apa pun di situs web ini atau aturan perdagangan;',
  p15: '5) Merchant涉嫌 mengarahkan pengguna ke platform lain untuk berdagang;',
  p16: '6) Merchant涉嫌 mengarahkan pengguna untuk mendaftar palsu, menipu hadiah promosi pengguna baru platform;',
  p17: '7) Merchant涉嫌 menasihati pengguna mitra platform ini untuk beralih ke platform lain untuk berdagang.',
  cxzg: 'Pasal 2: Pencabutan Kualifikasi Merchant',
  p18: 'Jika terjadi situasi berikut, platform berhak untuk mencabut kualifikasi merchant Anda secara sepihak:',
  p19: '1. Berulang kali dikeluhkan oleh pengguna platform ini dalam perdagangan;',
  p20: '2. Ada informasi palsu dalam materi aplikasi yang diajukan;',
  p21: '3. Terjadi perilaku tidak jujur seperti penipuan dalam perdagangan;',
  p22: '4. Tidak bekerja sama dengan layanan pelanggan platform ini untuk menangani pesanan atau sengaja menunda penanganan pesanan oleh layanan pelanggan;',
  p23: '5. Secara jahat menggunakan aturan platform ini untuk mencari keuntungan;',
  p24: '6. Melanggar hukum dan peraturan, perjanjian ini, atau dokumen hukum atau aturan perdagangan situs web ini;',
  p25: '7. Ada perilaku yang dinilai platform tidak sesuai dengan ketertiban umum dan perdagangan yang adil;',
  p26: '8. Perilaku ilegal lainnya.',
  zlbh: 'Pasal 3: Perlindungan Data Merchant',
  p27: '1. Manajemen data merchant: Materi verifikasi yang Anda kirimkan ke situs web ini saat mengajukan menjadi merchant (termasuk materi verifikasi identitas sebelumnya), akan不可撤销地 diotorisasi untuk disimpan oleh situs web ini. Situs web ini berjanji除了 alasan法定 atau约定, tidak akan mengungkapkan, mengedit, atau mengungkapkan materi verifikasi Anda, dan tidak akan menggunakan konten non-publik yang disimpan di situs web ini untuk tujuan komersial, tetapi除了 situasi berikut: Informasi terkait yang Anda otorisasi situs web ini untuk ungkapkan;',
  p28: '2. Situs web ini menyediakannya kepada peradilan dan administrasi negara;',
  p29: '3. Situs web ini menyediakannya kepada perusahaan afiliasi situs web ini;',
  p30: '4. Pihak ketiga dan situs web ini bersama-sama menyediakan layanan kepada pengguna, informasi terkait yang diperlukan pihak ketiga untuk menyediakan layanan kepada Anda;',
  p31: '5. Berdasarkan kebutuhan untuk menyelesaikan sengketa perdata antara Anda dan pihak ketiga, situs web ini berhak untuk menyediakan informasi identitas Anda kepada pihak ketiga tersebut.',
  sjcn: 'Pasal 4: Janji Merchant',
  p32: '1. Menerima semua ketentuan perjanjian ini adalah prasyarat untuk aplikasi verifikasi Anda.',
  p33: '2. Anda menyatakan dan menjamin, Anda tidak boleh untuk tujuan ilegal atau dilarang oleh perjanjian ini untuk melakukan aplikasi verifikasi.',
  p34: '3. Anda tidak boleh menggunakan layanan aplikasi dengan cara yang mungkin merusak, melumpuhkan, membebani berlebihan, atau merusak situs web lain atau layanan situs web lain atau situs web ini atau mengganggu penggunaan aplikasi merchant oleh orang lain.',
  p35: '4. Anda tidak boleh mendapatkan atau mencoba mendapatkan materi atau informasi apa pun dengan cara yang tidak diizinkan oleh situs web ini.',
  p36: '5. Anda mengonfirmasi dan berjanji: Anda menggunakan situs web ini untuk melakukan perdagangan bukan untuk tujuan melanggar hukum dan peraturan atau mengganggu ketertiban perdagangan aset digital situs web ini.',
  p37: '6. Merchant berjanji untuk mematuhi persyaratan pekerjaan pengungkapan informasi platform untuk melakukan perdagangan aset digital,提供 file, materi, atau informasi secara jujur sesuai dengan persyaratan platform. Jika merchant menolak untuk提供 file, materi, atau informasi yang diminta platform, maka pihak乙方 berhak untuk membuat keputusan pencabutan kualifikasi merchant sesuai dengan situasi.',
  ptmz: 'Pasal 5: Pembebasan Tanggung Jawab Platform',
  bcfx: 'Dalam situasi berikut, platform tidak menanggung tanggung jawab apa pun:',
  p38: '1. Karena Anda memberi tahu orang lain kata sandi akun atau tidak menjaga kata sandi Anda sendiri atau berbagi akun dengan orang lain atau kesalahan非 situs web ini,导致 kebocoran data pribadi Anda;',
  p39: '2. Serangan hacker, invasi atau发作 virus komputer, dampak penyesuaian teknis departemen telekomunikasi, penutupan sementara karena pengawasan pemerintah, karena alasan pihak ketiga (termasuk force majeure, seperti kegagalan satu pihak dari jalur tulang punggung出口 internasional dan penyedia layanan telekomunikasi出口 internasional, kebakaran, banjir, sambaran petir, gempa bumi, banjir, topan, tornado, letusan gunung berapi, epidemi wabah dan penyakit menular, pemogokan, perang atau kekerasan atau peristiwa serupa)及 alasan非 kesalahan situs web ini导致 kebocoran informasi verifikasi, kehilangan, pencurian, atau pemalsuan;',
  p40: '3. Karena situs web lain (seperti perbankan online, dll.) yang terhubung dengan situs web ini导致 kebocoran informasi akun bank及 konsekuensi hukum争议 dan后果;',
  p41: '4. Alasan apa pun karena pengguna提供 kesalahan, tidak lengkap, informasi tidak benar ke situs web ini导致 tidak dapat通过 verifikasi atau menderita kerugian lainnya, tidak ada hubungannya dengan situs web ini;',
  p42: '5. Karena alasan非 platform, aset Anda ditipu oleh orang lain.',
  ptts: 'Pasal 6: Tips Platform',
  p43: '1. Untuk mencapai审查 informasi identitas, situs web ini mungkin berisi tautan ke situs web pihak ketiga (seperti situs web perbankan online) (selanjutnya disebut sebagai \"situs web tertaut\"). \"Situs web tertaut\" tidak dikendalikan oleh situs web ini, untuk konten \"situs web tertaut\" apa pun, termasuk但不限于 tautan apa pun yang terkandung dalam \"situs web tertaut\", atau perubahan atau pembaruan \"situs web tertaut\", situs web ini tidak bertanggung jawab. Dari transmisi jaringan atau bentuk其他 yang diterima dari \"situs web tertaut\", situs web ini tidak bertanggung jawab.',
  p44: '2. Platform ini hanya menyediakan layanan platform perdagangan jaringan untuk Anda melakukan kegiatan perdagangan aset digital (包括但不限于 layanan perdagangan aset digital, dll.) melalui situs web ini, situs web ini tidak berpartisipasi sebagai pembeli atau penjual dalam perilaku perdagangan aset digital itu sendiri; situs web ini tidak menyediakan layanan terkait pengisian dan penarikan mata uang法定 negara.',
  p45: '3. Setelah Anda login ke situs web ini, menggunakan layanan apa pun dari situs web ini atau perilaku类似 lainnya, itu berarti Anda telah memahami dan sepenuhnya menyetujui semua konten perjanjian ini, termasuk modifikasi apa pun yang dilakukan situs web ini terhadap perjanjian ini sewaktu-waktu.',
  p46: '4. Saat Anda menggunakan situs web ini, mengklik tombol apa pun yang bertanda \"setuju\" atau arti类似 atau menggunakan layanan yang disediakan situs web ini dengan cara lain yang diizinkan situs web, itu berarti Anda sepenuhnya memahami, menyetujui, dan menerima semua ketentuan perjanjian ini, tidak ada tanda tangan tulisan tangan Anda pada perjanjian ini tidak memengaruhi效力 hukum perjanjian ini terhadap Anda.',
  p47: '5. Kami保留 hak untuk merevisi perjanjian ini dari waktu ke waktu, dan mengumumkannya melalui pengumuman situs web, tidak memberikan pemberitahuan terpisah kepada Anda, perjanjian yang diubah akan menandai waktu perubahan di beranda perjanjian ini,一旦 diumumkan di situs web, segera生效 otomatis.',
  tyxy: 'Saya Setuju dengan Isi Perjanjian Ini',
  nextStep: 'Langkah Selanjutnya'
}
const user = {
  txxz: 'Mengubah kata sandi dana tidak dapat menarik selama 24 jam',
  name: 'Nama Panggilan',
  rzdj: 'Tingkat Verifikasi Identitas',
  phone: 'Telepon',
  email: 'Email',
  zzc: 'Perkiraan Nilai Aset',
  hours24: '24 jam',
  market: 'Kondisi Pasar',
  notice: 'Pengumuman',
  more: 'Lainnya>>',
  cb: 'Isi Koin',
  tb: 'Tarik Koin',
  hz: 'Transfer',
  wsm: 'Belum Terverifikasi',
  cjrz: 'Verifikasi Dasar',
  gjrz: 'Verifikasi Lanjutan',
  qwgjrz: "Menuju Verifikasi Lanjutan",
  aqszx: 'Item Pengaturan Keamanan Telah Selesai',
  xgaqszx: 'Ubah Item Pengaturan Keamanan Anda',
  dlmm: 'Kata Sandi Login',
  zjdl: 'Dengan mengatur kata sandi login, Anda dapat langsung login menggunakan akun dan kata sandi login',
  ghmm: 'Ganti Kata Sandi',
  sz: 'Atur',
  jymm: 'Kata Sandi Transaksi',
  yzjymm: 'Saat dana akun berubah, perlu memverifikasi kata sandi transaksi terlebih dahulu.',
  ghjymm: 'Ganti Kata Sandi Transaksi',
  sjyz: 'Verifikasi Telepon',
  yzdx: 'Digunakan untuk menerima SMS verifikasi saat login, penarikan, mengubah kata sandi, pengaturan keamanan',
  xgsj: 'Ubah Nomor Telepon',
  zwbd: 'Belum Terikat',
  ggyz: 'Verifikasi Google',
  syzn: 'Panduan Penggunaan',
  bd: 'Ikat',
  yxyz: 'Verifikasi Email',
  tbqr: 'Anda dapat mengikat email yang sering digunakan,用于 login,找回 kata sandi, konfirmasi saat menarik koin',
  bdyx: 'Ikat Email',
  xgyx: "Ubah Email",
  xyx: "Email Baru",
  dljl: '10 Riwayat Login Terbaru',
  zjdljl: 'Ini adalah 10 riwayat login terbaru Anda',
  dlsj: 'Waktu Login Terbaru',
  ip: 'Alamat IP',
  aqsz: 'Pengaturan Keamanan',
  yhdl: 'Login Pengguna',
  xgbdsj: 'Ubah Nomor Telepon Terikat',
  bdsj: 'Ikat Nomor Telepon',
  dxyzm: 'Kode Verifikasi SMS',
  second: 'Detik',
  fsyzm: 'Kirim Kode Verifikasi',
  xsjh: 'Nomor Telepon Baru',
  ggyzm: 'Kode Verifikasi Google',
  yxyzm: 'Kode Verifikasi Email',
  confirm: 'Konfirmasi',
  edit: 'Ubah',
  name: 'Nama',
  srxm: 'Masukkan Nama',
  zjlx: 'Jenis Dokumen',
  xzzjlx: 'Pilih Jenis Dokumen',
  zjhm: 'Nomor Dokumen',
  srzjhm: 'Masukkan Nomor Dokumen',
  zcsr: 'Masukkan Kata Sandi Lagi',
  mmbyz: 'Kata sandi yang dimasukkan dua kali tidak sama!',
  sfz: 'KTP',
  jgz: 'Kartu Petugas',
  hz: 'Paspor',
  jmtxz: 'Kartu Izin Penduduk Taiwan',
  gatxz: 'Kartu Izin Penduduk Hong Kong-Makau',
  hwid: 'ID Luar Negeri',
  srdx: 'Masukkan Kode Verifikasi SMS',
  sryx: 'Masukkan Kode Verifikasi Email',
  srgg: 'Masukkan Kode Verifikasi Google',
  jdlmm: 'Kata Sandi Login Lama',
  xdlmm: 'Kata Sandi Login Baru',
  qrxmm: 'Konfirmasi Kata Sandi Baru',
  qrdlmm: 'Konfirmasi Kata Sandi Login',
  jjymm: 'Kata Sandi Transaksi Lama',
  xjymm: 'Kata Sandi Transaksi Baru',
  qrjymm: 'Konfirmasi Kata Sandi Transaksi',
  qwcyz: 'Selesaikan Verifikasi',
  smrz: 'Harap Lakukan Verifikasi Identitas Terlebih Dahulu',
  sryzm: 'Masukkan Kode Verifikasi',
  srsjh: 'Masukkan Nomor Telepon',
  xgdlmm: 'Ubah Kata Sandi Login',
  szdlmm: 'Atur Kata Sandi Login',
  xgjymm: 'Ubah Kata Sandi Transaksi',
  szjymm: 'Atur Kata Sandi Transaksi',
  czmm: 'Atur Ulang Kata Sandi',
  
  bdgg: 'Ikat Google Authenticator',
  lbyzq: 'Harap unduh Google Two-Step Authenticator',
  smewm: 'Gunakan Google Two-Step Authenticator untuk memindai kode QR',
  srdm: 'Jika kode QR tidak dapat dikenali, harap masukkan kode berikut secara manual',
  copy: 'Salin',
  copySuccess: 'Salin Berhasil',
  sryx: 'Masukkan Email',
  srzqyx: 'Masukkan Alamat Email yang Benar',
  srsjyzm: 'Masukkan Kode Verifikasi SMS',
  sryxyzm: 'Masukkan Kode Verifikasi Email',
  srggyzm: 'Masukkan Kode Verifikasi Google',
  passwordTypeError: 'Format kata sandi salah, kata sandi harus 8-32 digit,同时 berisi huruf besar dan kecil serta angka.',
  passwordDiff: 'Kata sandi yang dimasukkan dua kali tidak sama',
  zcsrxmm: 'Masukkan Kata Sandi Lagi',
  language: 'Bahasa',
  bdhb: 'Mata Uang Lokal',
  wdbph: 'Preferensi Stablecoin',
  
  相关问题:"Pertanyaan Terkait",
  为什要进行身份认证:"Mengapa Perlu Verifikasi Identitas",
  上传中:"Mengunggah...",
  开始上传:"Mulai Unggah",
  录制第一段视频:"Rekam Video Pertama",
  录制第二段视频:"Rekam Video Kedua",
  录制完成:"Rekaman Selesai",
  请手持身份证正面:"Harap pegang bagian depan KTP, letakkan di bawah wajah",
  正对摄像头:"Hadapi kamera, pertahankan selama 5 detik atau lebih",
  摘下眼镜:"Lepaskan kacamata, topi, dan penghalang lainnya",
  请按视频文字提示录制视频:"Harap rekam video sesuai petunjuk teks video",
  开始录制:"Mulai Rekam",
  第一段视频:"Video Pertama",
  第二段视频:"Video Kedua",
  录制一段视频:"Rekam Satu Video",
  点击开始录制:"Klik untuk Mulai Rekam",
  视频录像认证:"Verifikasi Rekaman Video",
  身份证号:"Nomor KTP",
  证件验证: "Verifikasi Dokumen (Foto/Scan)",
  zjyz: "Verifikasi Dokumen",
  请确保图片格式为:"Harap pastikan format gambar adalah jpg/jpeg/png, pastikan ukuran gambar小于 2mb",
  请手持证件照:"Harap pegang foto dokumen dan tanda tangan pribadi, tanda tangan pribadi需要 termasuk Biking+ tanggal hari ini",
  当日签名照:"Foto memegang dokumen + foto tanda tangan hari ini",
  上传证件签名页:"Unggah halaman tanda tangan dokumen",
  请保证所有信息清晰:"Harap pastikan semua informasi jelas",
  上传证件页信息:"Unggah informasi halaman dokumen",
  请选择国家:"Pilih Negara",
  请上传正面证件照:"Unggah foto depan dokumen",
  请上传反面证件照:"Unggah foto belakang dokumen",
  手持证件照:"Foto memegang dokumen",
  请选择区域:"Pilih Wilayah",
  认证要求: "Persyaratan Verifikasi",
  证件信息: "Informasi Dokumen",
  人脸识别: "Pengenalan Wajah",
  立即认证: "Verifikasi Sekarang",
  认证要求: "Persyaratan Verifikasi",
  什么是加密货币P2P交易: "Apa itu Perdagangan Cryptocurrency P2P",
  最好的P2P加密货币交易所是什么: "Apa Exchange Cryptocurrency P2P Terbaik?",
  P2P交易的成本有多少: "Berapa Biaya Perdagangan P2P?",
  什么是BikingP2P上的商家: "Apa itu Merchant di BiKing P2P?",
  我们正在审核您的申请: "Kami sedang memproses aplikasi Anda",
  预计审核时间: "Perkiraan waktu verifikasi: 72 jam",
  驳回: "Ditolak",
  未提交: "Belum Dikirim",
  手续费等级: "Tingkat Biaya",
  去认证: "Pergi Verifikasi",
  已认证: "Telah Terverifikasi",
  开通更多权限: "Verifikasi identitas, buka lebih banyak izin",
  在别人贪婪时要保持警惕:"Berhati-hatilah saat orang lain serakah, dan jadilah serakah saat orang lain berhati-hati — Buffett",
  kyc声明: 'Saya {Name}, nomor dokumen adalah: {No}. Saya dengan sukarela mendaftar dan berdagang di Biking, dan menjamin akun digunakan oleh saya sendiri, saya menjamin semua sumber aset legal, telah memahami dan dapat menanggung semua risiko perdagangan, aset digital yang ditarik tidak digunakan untuk tujuan ilegal, dan juga tidak akan menggunakan platform ini untuk kegiatan ilegal apa pun, seperti pencucian uang, skema piramida, dan pertukaran valuta asing ilegal.',
  编辑头像:"Edit Avatar",
  请选择一个头像用作您个人资料的照片:"Pilih avatar untuk digunakan sebagai foto profil Anda",
  中国:"Tiongkok",
  其他:"Lainnya" ,
  questionTitle1: '1. Mengapa perlu提供 verifikasi identitas?',
  questionSubTitle1: '币王 mengadopsi layanan verifikasi identitas yang mematuhi全球, menjamin keamanan dana semua pengguna. Oleh karena itu, saat mengisi informasi, harap提供 materi yang memenuhi persyaratan.',
  questionTitle2: '2. Apa keuntungan menyelesaikan verifikasi identitas?',
  questionSubTitle2: 'Semua pengguna harus menyelesaikan verifikasi identitas方可 mengakses fungsi OTC币王. Pengguna yang belum menyelesaikan verifikasi identitas tidak memengaruhi pengisian dan penarikan on-chain.',
  questionTitle3: '3. Bagaimana memperbarui verifikasi identitas?',
  questionSubTitle3: 'Jika informasi identitas Anda berubah dan memenuhi kondisi berikut, Anda dapat menghubungi layanan pelanggan online untuk mengajukan aplikasi pembaruan verifikasi identitas:',
  questionTitle4: '4. Berapa lama waktu yang dibutuhkan untuk verifikasi KYC?',
  questionSubTitle4: 'Informasi yang Anda kirimkan biasanya akan diverifikasi dalam 5 menit. Namun, dalam keadaan khusus可能需要 waktu lebih lama.',
  questionTitle5: '5. Apakah verifikasi identitas币王 aman?',
  questionSubTitle5: 'Verifikasi identitas币王 aman, ini membantu kami membangun platform yang aman untuk Anda dan semua pengguna lainnya. File Anda juga保密 bagi kami.',
  questionTitles:'1. Dokumen telah kedaluwarsa;',
  questionTitles1:'2. Nama pada dokumen telah berubah;',
  questionTitles2:'3. Nomor identitas pada dokumen telah berubah;',
  questionTitles3:'4. Kewarganegaraan telah berubah;',
  questionTitles4:'5. Perbarui dokumen untuk memastikan penggunaan fiat normal;',
  questionTitles5:'6. Ubah ke nama yang dikenali oleh bahasa sistem (misalnya: dari KTP domestik ke paspor);',
  Z1001: "Kesalahan Sistem",
  Z1003: "Verifikasi Terputus",
  Z2002: "Kesalahan Jaringan",
  Z2003: "Waktu Perangkat Klien Salah",
  Z2006: "Verifikasi Gagal",
  Z5050: "Verifikasi Wajah Berhasil",
  Z5051: "Gagal Mengunggah Gambar Pemindaian Wajah",
  Z5052: "Data错误 atau program异常.",
  Z5053: "Kesalahan Jaringan.",
  Z5054: "Kamera tidak memiliki izin atau tidak dapat mengambil data kamera.",
  Z5055: "Pengguna keluar.",
  Z5056: "Terlalu banyak percobaan.",
  Z5057: "Unggahan video timeout.",
  Z5058: "Format video tidak memenuhi persyaratan.",
  Z5059: "Tidak ada wajah yang valid dalam video.",
  Z5128: "Verifikasi bukan orang yang sama.",
  法币充值:'Batas Isi/Tarik Fiat',
  无限额:'Tidak Terbatas',
  数字货币充值:'Isi Mata Uang Digital',
  数字货币提现限额:'Batas Penarikan Mata Uang Digital',
  C2C交易限额:'Batas Perdagangan C2C',
  "参数不合法": 'Parameter Tidak Sah',
  h5smrz: "Verifikasi Identitas",
  bhzhan: "Atur kata sandi, lindungi keamanan akun Anda",
  jxsmrz: "Lakukan verifikasi identitas, jamin keamanan dana pengguna",
  qwrz: "Menuju Verifikasi",
  dgzhzd: "1. Satu akun dapat dikirimkan maksimal 5 kali per hari.",
  rhzp: "2. Foto, video, atau detail dokumen yang Anda kirim tidak akan disimpan atau digunakan dengan cara apa pun.",
  sfzm: "Bukti Identitas",
  zjqfg: "Negara Penerbit Dokumen",
  dw: "Penentuan Posisi",
  sfxx: "Informasi Identitas",
  dqdw: "Lokasi Saat Ini",
  gjdq: "Negara/Wilayah"
}

const h5 = {
  chart: 'Grafik',
  mmp: 'Buku Order',
  sscj: 'Transaksi Real-time',
  wt: 'Order',
  lswt: 'Order Sejarah',
  zj: 'Dana',
  sj: 'Harga Pasar',
  ky: 'Tersedia',
  zczh: 'Konversi Aset',
  dj: 'Dibekukan',
  zwsj: 'Belum Ada Data',
  zx: 'Pilihan',
  buysell: 'Beli/Jual'
}

const worldCup = {
  common: {
    cancel: 'Membatalkan',
    confirm: 'mengonfirmasi',
    iKnow: 'Jadi begitu',
    points: 'integral',
    day: 'langit',
    hour: 'Jam',
    minute: 'titik',
    second: 'Kedua',
    noData: 'Tidak ada data',
    noMatch: 'Belum ada pertandingan',
    businessClosed: 'Layanan telah ditutup',
    loadFailed: 'Gagal memuat, silakan coba lagi nanti',
  },
  index: {
    liveFeed: 'dinamika waktu nyata',
    heroTitle: 'Bertaruh pada Piala Dunia',
    heroSplit: 'mengukir',
    heroPrizePool: 'Kumpulan hadiah',
    heroMillionPrizePool: 'Bagi hadiah 1 juta',
    heroSub: 'Ada juga tiket Tesla dan Piala Dunia yang menunggu Anda.',
    heroJoinedPrefix: 'Sudah',
    heroJoinedSuffix: 'Orang-orang berpartisipasi, dan kumpulan hadiah terus bertambah.',
    activityTimeLabel: 'Waktu aktivitas:',
    refreshing: 'Menyegarkan...',
    releaseToRefresh: 'Lepaskan untuk segera menyegarkan',
    pullToRefresh: 'Tarik ke bawah untuk menyegarkan',
    livePrizePool: 'Kumpulan hadiah waktu nyata',
    growing: 'Berkembang secara real time',
    userPoolRatioLabel: 'Pengguna individu dapat berbagi kumpulan hadiah:',
    teamPoolRatioLabel: 'Tim dapat berbagi kumpulan hadiah:',
    poolCountdownLabel: 'Hitung mundur pembagian kumpulan hadiah tahap {phase}',
    poolCountdownFinalLabel: 'Hitung mundur menuju pembagian pool hadiah tahap final',
    poolActivityStartCountdownLabel: 'Hitung mundur menuju dimulainya acara',
    poolSplitDoneBadge: 'Pembagian kumpulan hadiah selesai',
    totalAllocatedPoolLabel: 'Total kumpulan hadiah terbagi',
    poolAllocateFirst: 'Pembagian ke-1',
    poolAllocateSecond: 'Pembagian ke-2',
    poolAllocateThird: 'Pembagian ke-3',
    poolAllocateFinal: 'Pembagian akhir',
    poolTeamPrefix: 'Tim: ',
    poolPersonalPrefix: 'Individu: ',
    poolPersonalCount: 'Individu: {n} orang',
    teamTitle: 'Bentuk tim dan gandakan penghasilan Anda',
    teamSubPrefix: 'Bergabunglah dengan tim dan dapatkan kesempatan untuk berkembang',
    teamSubSuffix: 'penghasilan',
    teamAgentTitle: 'Tim agen',
    teamAgentDesc: 'Agen platform dapat membentuk tim dengan satu klik, dan <span class="wc-hl"> poin anggota tim akan dikumpulkan menjadi total poin tim </span>. Pada saat yang sama, menyelesaikan tugas tim dapat memperoleh <span class="wc-hl"> poin tim tambahan </span>. Semakin tinggi poin tim, semakin besar peluang <span class="wc-hl"> untuk berbagi kumpulan hadiah </span>.',
    createTeamNow: 'Bentuk tim sekarang',
    applyAgentNow: 'Saya bukan agen, ajukan lamaran sekarang',
    teamUserTitle: 'tim kebebasan',
    teamUserDesc: 'Tidak perlu menjadi agen, Anda dapat bergabung dengan tim gratis, membentuk tim dengan pengguna gratis lainnya, berpartisipasi dalam <span class="wc-hl2"> poin tim</span>, dan mendapatkan <span class="wc-hl2"> peluang berbagi kumpulan hadiah</span>.',
    joinNow: 'Bergabunglah sekarang',
    championTitle: 'Prediksi Kejuaraan',
    championSub: 'Setiap pengguna hanya dapat memprediksi satu kali, dan tidak dapat diubah setelah dikunci. Jika tebakannya benar, Anda berhak berbagi kumpulan hadiah satu per satu.',
    championHintPrefix: 'Pengguna yang memprediksi pemenang dengan benar akan menerima kumpulan hadiah',
    championHintSuffix: 'kualifikasi untuk mengukir',
    championPoolShare: 'kualifikasi untuk mengukir',
    championWin: 'Selamat telah menebak pemenangnya',
    championLose: 'Maaf, Anda tidak menebak dengan benar',
    championWinSub: 'dapatkan kualifikasi untuk berbagi kumpulan hadiah individu.',
    championNoParticipation: 'Acara telah berakhir, Anda tidak ikut prediksi',
    confirmPredict: 'Konfirmasikan perkiraan',
    predictCountdown: 'Hitung Mundur Prediksi',
    predictEnded: 'Prediksi telah berakhir',
    notice1: 'Pengguna p***12 baru saja menyelesaikan taruhan dan memenangkan 500 poin',
    notice2: 'Pengguna k***88 baru saja menukarkan Tesla',
    notice3: 'Pengguna a***23 baru saja menyelesaikan taruhan dan memenangkan 1200 poin',
    notice4: 'Pengguna x***56 mengundang teman untuk mendapatkan 100 poin',
    notice5: 'Pengguna m***07 baru saja menukarkan 1 tiket Piala Dunia',
    tabPredict: 'Pertaruhan',
    tabTask: 'Tugas',
    tabRank: 'peringkat',
    tabExchange: 'menukarkan',
    tabMine: 'milikku',
    tabRules: 'aturan',
  },
  toast: {
    refreshSuccess: 'Penyegaran berhasil',
    predictSuccess: 'Prediksi berhasil, hasil telah dikirimkan',
    inviteJumping: 'Lompat ke halaman undangan...',
    applyAgentPending: 'Fungsi aplikasi agen sedang dalam pengembangan, jadi pantau terus!',
    championLocked: 'Prediksi kejuaraan terkunci!',
    exchangeSubmitted: 'Permohonan penukaran telah berhasil diajukan, dan layanan pelanggan platform akan menghubungi Anda untuk distribusi hadiah.',
    pointsNotEnough: 'Poin tidak cukup',
    createTeamSubmitted: 'Tim berhasil dibuat',
    joinedFreeTeam: 'Bergabung dengan Tim Kebebasan',
  },
  section: {
    predictTitle: 'Prediksi Kejuaraan', 
    predictSub: 'Prediksi hasil pertandingan, menang+{correctPoints} poin, kalah+{wrongPoints} poin',
    predictRules: 'Deskripsi Prediksi',
    taskTitle: 'Selesaikan Tugas untuk Menghasilkan Poin',
    taskSub: 'Berbagai tugas dan reward, mempercepat peningkatan keuntungan',
    exchangeTitle: 'Toko Penukaran Poin',
    exchangeSub: 'Hadiah berlimpah, dapatkan sebelum semua habis',
    exchangeRules: 'Deskripsi Penukaran',
    rankTitle: 'Peringkat Nyata',
    rankSub: 'Bersaing dan mencapai puncak',
    rulesTitle: 'Aturan Acara',
    rulesSub: 'Transparan, terbuka, dan adil',
  },
  dialog: {
    taskTitle: 'Pernyataan misi',
    taskReward: 'Tersedia setelah selesai',
    predictConfirmTitle: 'Taruhan pertandingan',
    predictConfirmHint: 'Menurut Anda tim mana yang akan menang?',
    predictPay: 'membayar',
    predictPayTip: 'Dikurangi dari rekening modal, pastikan saldo mencukupi',
    predictConfirmBtn: 'Konfirmasikan taruhan',
    predictSuccessTitle: 'Taruhannya berhasil',
    predictSuccessDesc: 'Hasil taruhan telah berhasil dikirimkan, dan catatannya dapat dilihat di "Taruhan Saya".',
    exchangeTitle: 'Pertukaran produk',
    exchangeNeedPoints: 'Poin diperlukan',
    exchangeBalance: 'Keseimbangan:',
    exchangeContactTitle: 'Isi setidaknya satu informasi kontak',
    exchangeTipTitle: 'Tip yang baik',
    exchangeTip1: 'Silakan isi setidaknya satu informasi kontak. Setelah pengajuan, layanan pelanggan platform akan menghubungi Anda untuk berkomunikasi tentang distribusi hadiah.',
    exchangeTip2: 'Jika Anda sudah lama tidak dihubungi, silakan hubungi layanan pelanggan untuk diproses.',
    exchangeConfirm: 'Konfirmasikan pertukaran',
    teamJoinTitle: 'Bergabunglah dengan tim',
    teamCreateDesc: 'Apakah Anda yakin akan membentuk tim?',
    teamJoinFreeDesc: 'Apakah Anda yakin untuk bergabung dengan Tim Freedom?',
    teamJoinTipTitle: 'Tip yang baik',
    teamJoinTipDesc: 'Anda adalah anggota tim agen dan tidak dapat bergabung dengan tim gratis. Anda dapat mengundang pengundang (agen) Anda untuk membentuk tim untuk berpartisipasi dalam pertarungan tim.',
    applyAgentContactTitle: 'Pemberitahuan penting',
    applyAgentContactPrefix: 'Silakan tambahkan Telegram: ',
    applyAgentContactSuffix: ' untuk mendaftar sebagai agen. Setelah menjadi agen, Anda dapat membuat tim.',
    applyAgentContactBtn: 'Mengerti',
  },
  rank: {
    teamRank: 'Peringkat tim',
    personRank: 'Peringkat pribadi',
    yourTeamRank: 'Peringkat tim Anda',
    yourPersonRank: 'peringkat pribadi Anda',
    captain: 'pemimpin tim:',
    currentPoints: 'Poin saat ini',
    members: 'anggota',
    teamDetail: 'Detail tim',
    noRankYet: 'Belum ada peringkat',
  },
  mine: {
    myPoints: 'poin saya',
    totalPoints: 'poin total',
    myPredict: 'Taruhan saya',
    myExchange: 'Pertukaran saya',
    myBonus: 'Bonus saya',
    totalBonus: 'Total bonus yang saya terima',
    bonusPhase: 'Tahap pembagian:',
    bonusPhaseFirst: 'Tahap 1',
    bonusPhaseSecond: 'Tahap 2',
    bonusPhaseThird: 'Tahap 3',
    bonusPhaseFinal: 'Tahap akhir',
    bonusTypeTeam: 'Pembagian tim',
    bonusTypePersonal: 'Pembagian individu',
    bonusPoints: 'Poin saat pembagian:',
    bonusType: 'Jenis:',
    bonusAmount: 'Bonus:',
    myTeam: 'tim saya',
    selectTeam: 'Pilih tim',
    predictMatch: 'Pertandingan',
    winTeam: 'tim pemenang',
    predictResult: 'Hasil taruhan',
    hit: 'Menebak dengan benar',
    miss: 'Tidak dapat ditebak',
    draw: 'Seri',
    exchangeItem: 'Tukarkan barang',
    contactInfo: 'Informasi kontak',
    exchangeStatus: 'Status penebusan',
    currentRank: 'Peringkat saat ini',
    notJoinedTeam: 'Belum bergabung dengan tim',
    memberContribution: 'Kontribusi anggota',
    teamTaskContribution: 'Kontribusi tugas tim',
    loading: 'memuat...',
    statusDone: 'Selesai',
    statusPending: 'Pengolahan',
    statusFail: 'Penukaran gagal',
    logCompleteKyc: 'Selesaikan KYC',
    logExchangePrize: 'Penukaran hadiah',
    logMatchPredict: 'Taruhan pertandingan',
    logDailySign: 'Check-in harian',
    logFinishTask: 'Selesaikan tugasnya',
    taskFirstRecharge: 'Menyelesaikan pengisian ulang pertama >= {amount} USDT',
    pagerTotal: 'Total {total} item',
    prevPage: 'Halaman sebelumnya',
    nextPage: 'Halaman selanjutnya',
    goTo: 'Pergi ke',
    page: 'Halaman',
  },
  mobile: {
    title: 'Taruhan Piala Dunia',
  },
  nav: {
    entry: 'Taruhan Piala Dunia',
  },
  mock: {
    korea: 'Korea Selatan',
    germany: 'Jerman',
    china: 'Cina',
    uk: 'Inggris',
    france: 'Perancis',
    portugal: 'Portugal',
    senegal: 'Senegal',
    brazil: 'Brazil',
    india: 'India',
    turkiye: 'Turki',
    usa: 'Amerika Serikat',
    jerseyPack: 'Set jersey resmi',
    vipCard: 'Kartu keanggotaan terenkripsi VIP',
    jerseyKeyword: 'kaos',
  },
  predict: {
    round: {
      group: 'penyisihan grup',
      r32: 'babak 32 besar',
      r16: 'babak 16 besar',
      quarter: 'perempat final',
      semi: 'semifinal',
      third: 'pertandingan perebutan tempat ketiga',
      final: 'final',
    },
    status: {
      joined: 'Sudah berpartisipasi',
      open: 'Membuka',
      ongoing: 'Selama pertandingan',
      ended: 'berakhir',
    },
    btn: {
      joined: 'Sudah bertaruh',
      open: '{betPaymentAmount}USDT Taruhan sekarang',
      ongoing: 'Permainan sedang berlangsung',
      ended: 'Taruhan telah berakhir',
    },
    joinedMatchPhase: {
      pending: 'Belum dimulai',
      ongoing: 'Berlangsung',
      ended: 'Selesai',
    },
    joinedResult: {
      hit: 'Benar +{points}',
      missPrefix: 'Salah',
      missSuffix: '+{points}',
    },
  },
  rules: {
    fundSource: 'Sumber dana',
    poolSplit: 'Pembagian kumpulan hadiah',
    teamIntro: 'Deskripsi Tim',
    poolRulesTitle: 'Deskripsi kumpulan hadiah',
    teamRulesTitle: 'Deskripsi Tim',
    predictRulesTitle: 'Instruksi taruhan',
    exchangeRulesTitle: 'Instruksi penebusan',
  },
  rulesText: {
    poolDesc1: 'Hadiah awal {initialFunds} USDT, selama periode aktivitas, bagian dari pendapatan bisnis dimasukkan ke kumpulan hadiah untuk meningkatkannya',  
    poolLine1: ' {rechargePercentageToPool}% dari setiap deposit masuk ke kumpulan hadiah secara otomatis;',
    poolLine2: '{contractFeePercentageToPool}% dari setiap biaya transaksi kontrak perpetual masuk ke kumpulan hadiah secara otomatis;',
    poolLine3: ' Setiap pengguna yang mengundang pengguna valid, kumpulan hadiah meningkat secara otomatis sebesar {additionalAmountPerValidUser} USDT.',
    poolLine4: '*Jumlah di bawah 0,01 USDT tidak akan dihitung dalam kumpulan hadiah.',
    teamPoolTitle: 'Tim membagi kumpulan hadiah',
    teamPoolRuleTitle: 'Aturan pembagian kumpulan hadiah tim',
    teamPoolRule1: 'Tim yang memperoleh hadiah, pemimpin (tim kebebasan tidak termasuk) memperoleh 20% dari hadiah pembagian, hadiah pemimpin = total kumpulan hadiah * proporsi pembagian * 20%',
    teamPoolRule2: 'Tim yang memperoleh kualifikasi pembagian hadiah berdasarkan kontribusi poin pribadi masing-masing anggota tim, hadiah pribadi = [(total kumpulan hadiah * proporsi pembagian tim) * (1 - 0.2) / jumlah poin tim yang memiliki kualifikasi] * poin pribadi total',
    userPoolTitle: 'Aturan pembagian kumpulan hadiah pribadi',
    poolSplit1: 'Pertama: setelah tim 8 besar ditentukan, tim dengan peringkat pertama menangkan {percentage}% kumpulan hadiah, sisa kumpulan hadiah terus bertambah',
    poolSplit2: 'Kedua: setelah tim 4 besar ditentukan, tim dengan peringkat pertama menangkan {percentage}% kumpulan hadiah, sisa kumpulan hadiah terus bertambah',
    poolSplit3: 'Ketiga: setelah semifinal, tim dengan peringkat pertama menangkan {percentage}% kumpulan hadiah, sisa kumpulan hadiah terus bertambah',
    poolSplit4: 'Akhir: setelah final, tim peringkat pertama membagi {percentage}% dari total kumpulan hadiah. Setelah pembagian selesai, poin tersedia anggota tim akan direset ke nol',
    userPoolLine1: 'Permainan selesai, pengguna yang menebak pemenang pertandingan menangkan kualifikasi pembagian kumpulan hadiah pribadi',
    userPoolLine2: 'Semua pengguna yang menebak juara dengan benar membagi {percentage}% dari kumpulan hadiah berdasarkan total poin pribadi. Setelah pembagian selesai, poin tersedia pribadi akan direset ke nol',
    poolFormula: '*Contoh: sebuah tim memiliki N pengguna yang memenuhi syarat pembagian, poin tiap pengguna adalah N1, N2, N3...Nn, total prize pool saat pembagian adalah A, rasio pembagian tahap ini 20%, rasio hadiah kapten 20%, maka hadiah anggota tim = [(A*20%)(1-0.2)/(N1+N2+N3+...+Nn)]*total poin pribadi',
    teamRule1: '1. Hanya agen level 1 yang dapat membentuk tim, jika bukan agen, dapat mengajukan menjadi agen, lalu membentuk tim',
    teamRule2: '2. Jika bukan agen dan tidak memiliki kualifikasi agen, dapat bergabung dengan tim yang ditetapkan oleh platform (pengguna yang bukan agen)',
    teamRule3: '3. Setelah tim dibentuk, anggota tim secara otomatis menjadi satu tim',
    teamRule4: '4. Total poin tim = jumlah poin anggota tim + poin tugas tim',
    teamRule5: '5. Kualifikasi pembagian kumpulan hadiah tim: berpartisipasi dalam taruhan≥{quizTimesThreshold} kali + volume kontrak perpetual ≥{poolContractThreshold}U',
    predictRule1: '1. Setelah pertandingan dimulai, taruhan akan ditutup',
    predictRule2: '2. Setiap pengguna hanya dapat berpartisipasi dalam taruhan 1 kali per pertandingan',
    predictRule3: '3. Taruhan memerlukan pembayaran {betPaymentAmount} USDT',
    predictRule4: '4. Menangkan tim pemenang +{correctBonusPoints} poin, kalah +{wrongBonusPoints} poin',
    predictRule5: '5. Jika pertandingan (grup) adalah "imbang", maka poin dihitung sebagai kalah, +{wrongBonusPoints} poin',
    exchangeRule1: '1. Hadiah terbatas, habis saat ini; dapatkan sebelum semua habis',
    exchangeRule2: '2. Setelah pertukaran, poin tim Anda akan dikurangi',
    exchangeRule3: '3. Saat pertukaran, isi informasi kontak, dan layanan pelanggan platform akan menghubungi Anda untuk berkomunikasi tentang distribusi hadiah.',
    exchangeRule4: '4. Jika informasi kontak yang Anda isi salah, pertukaran hadiah akan gagal, silakan periksa dan isi kembali.',
    exchangeRule5: '5. Jika Anda lama tidak dihubungi, silakan hubungi layanan pelanggan untuk diproses.',
    timeTitle: 'Waktu aktivitas',
    activePeriodLabel: 'Waktu aktivitas:',
    activePeriodValue: '{startTime} ~ {endTime}',
    activeTip: 'Setelah aktivitas dimulai, poin akan dihitung dan dihitung, dan kumpulan hadiah akan mulai bertambah',
    predictPeriodLabel: '竞猜时间：',
    predictPeriodValue: 'Taruhan pemenang：{startTime} ~ {endTime}',
    businessTitle: 'Aturan bisnis',
    businessRule1: '1. Pengguna yang mengundang valid: pengguna yang mengundang adalah pengguna yang melakukan deposit ≥{inviteRechargeThreshold}U, dan volume kontrak perpetual ≥{contractVolumeThreshold}U',
    businessRule2: '2. Kualifikasi pembagian kumpulan hadiah tim: berpartisipasi dalam taruhan≥{quizTimesThreshold} kali + volume kontrak perpetual ≥{poolContractThreshold}U',
    businessRule3: '3. Poin pribadi dapat ditukarkan kapan saja, setelah ditukarkan, poin pribadi dan tim Anda akan dikurangi',
    businessRule4: '4. Hadiah实物奖品数量有限，兑完为止',
    businessRule5: '5. Tiket Piala Dunia兑换截止世界杯开幕前一日，因不可抗力因素导致无法兑换实物门票可兑换等值USDT',
    statementTitle: 'Pernyataan resmi',
    statement1: '1. Setiap pengguna hanya dapat menggunakan satu akun untuk berpartisipasi dalam aktivitas, jangan menggunakan beberapa akun (termasuk, tetapi tidak terbatas pada pembuatan akun secara massal, akun terkait, dll) untuk berpartisipasi dalam aktivitas, sistem akan memantau perangkat login dan alamat IP akun yang digunakan, jika ditemukan beberapa akun menggunakan perangkat login dan alamat IP yang sama, platform memiliki hak untuk menentukan bahwa akun tersebut adalah akun terkait;', 
    statement2: '2. Perilaku perdagangan pengguna harus benar dan sah, jangan melakukan perdagangan palsu, perdagangan palsu, atau perdagangan self-done',
    statement3: '3. Platform akan mengenali perilaku perdagangan yang aneh melalui sistem pengawasan risiko, termasuk, tetapi tidak terbatas pada: perdagangan tinggi frekuensi terbalik, perdagangan kontrak harga yang sama, perdagangan self-done rendah risiko, dll',
    statement4: '4. Jika ditemukan perilaku perdagangan yang aneh, platform memiliki hak: menghapus poin dari transaksi yang dibatalkan, menarik hak berpartisipasi dalam aktivitas, membekukan atau mengambil kembali hadiah terkait',
    statement5: '5. Jumlah hadiah dan pembagian hadiah ditentukan oleh platform berdasarkan hasil akhir, platform memiliki hak untuk menjelaskan aturan akhir',
  },
  exchange: {
    needPoints: 'Poin diperlukan',
    stock: 'sisa stok',
    buyNow: 'Tukarkan sekarang',
    soldOut: 'Terjual habis',
    badgeUnique: 'Satu-satunya hadiah utama di situs ini',
    badgeOnlyCount: 'Hanya {count} item',
    itemFinalTicket: 'Tiket Final Piala Dunia',
    itemSignedFootball: 'sepak bola bertanda tangan',
  },
  task: {
    earnPoints: 'Hasilkan poin',
    goFinish: 'untuk menyelesaikan',
    goTeamTask: 'Kerjakan tugas untuk poin tim',
  },
  taskGroup: {
    daily: 'tugas sehari-hari',
    invite: 'Undang tugas',
    recharge: 'Isi ulang tugas',
    teamTrade: 'Tugas perdagangan tim',
    dailyLimitPrefix: 'Batas hadiah harian',
    teamLimitPrefix: 'Batas hadiah harian tim',
    limitPoints: '{num} poin',
    limitSuffix: ', disegarkan setiap hari pada 00:00:00 (GMT+08:00)',
    rechargeLimitSuffix: 'Hanya pengisian ulang pertama selama periode acara yang akan dihitung untuk melihat apakah memenuhi standar.',
    inviteCta: 'Undang sekarang dan dapatkan poin',
    taskPredictOnce: 'Setiap kali Anda berpartisipasi dalam suatu acara taruhan',
    taskTrade10000: 'Setiap volume transaksi kontrak perpetual kumulatif yang diselesaikan adalah {tradeVolume}U',
    taskInviteValidUser: 'Setiap kali undangan pengguna yang valid selesai',
    taskInviteRegister: 'Undang teman untuk mendaftar',
    taskInviteKyc: 'Undang teman untuk menyelesaikan KYC',
    taskInviteRecharge: 'Undang teman untuk menyelesaikan isi ulang pertama',
    taskFirstRecharge: 'Pengisian ulang pertama >= {amount} USDT',
    taskTeamTrade10000: 'Untuk setiap volume transaksi kontrak perpetual kumulatif {tradeVolume} USDT yang diselesaikan, tim akan menerima +{teamBonusPoints} poin.',
  },
};
export {
  games,
  h5,
  trading,
  download,
  login,
  user,
  advertise,
  otcMerchant,
  otc,
  menu,
  time,
  state,
  text,
  seckillRes,
  header,
  hyy,
  index,
  indexPage,
  Verification,
  NAVS,
  FOOTERS,
  SIDEBAR,
  seckill,
  apply,
  recommend,
  market,
  banner,
  card,
  news,
  info,
  navCard,
  choice,
  plat,
  risk,
  license,
  footer,
  merchandiser,
  codeInfo,
  placeOrder,
  tableList,
  codelist,
  contractHyy,
  common,
  dialog,
  panKou,
  invite,
  property,
  contest,
  taskCenter,
  ieo,
  earn,
  tradingContest,
  agent,
  live,
  hongbao,
  worldCup
};


// WEBPACK FOOTER //
// ./src/i18n/lang/public/ba.js